(()=>{if(window.TurtlesonWardrobeLogic){window.TurtlesonWardrobeLogic.initializeAll();return;}let activeCurrency="USD";
const catalog = {
  "snapshotDate": "2026-10-08",
  "items": {
    "shadow": {
      "id": "shadow",
      "productId": "briggs-1-4-zip",
      "handle": "briggs-1-4-zip",
      "title": "Briggs Quarter Zip",
      "color": "Shadow",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 13500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/briggs-quarter-zip-8395498.jpg?v=1786405213",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/briggs-quarter-zip-8395498.jpg?v=1786405213",
      "url": "/products/briggs-1-4-zip?variant=59756582011166",
      "variants": [
        {
          "id": "59756582011166",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-E0016-S"
        },
        {
          "id": "59756582043934",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-E0016-M"
        },
        {
          "id": "59756582076702",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-E0016-L"
        },
        {
          "id": "59756582109470",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-E0016-XL"
        },
        {
          "id": "59756582142238",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-E0016-2XL"
        },
        {
          "id": "59756582175006",
          "options": {
            "Size": "3XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-E0016-3XL"
        },
        {
          "id": "59756582207774",
          "options": {
            "Size": "4XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-E0016-4XL"
        },
        {
          "id": "59756582240542",
          "options": {
            "Size": "5XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-E0016-5XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "duncan-dot-performance-polo--sky": {
      "id": "duncan-dot-performance-polo--sky",
      "productId": "duncan-dot-performance-polo",
      "handle": "duncan-dot-performance-polo",
      "title": "Duncan Dot Cotton Polo",
      "color": "Sky",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 12500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/duncan-dot-cotton-polo-9044885.jpg?v=1776284592",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/duncan-dot-cotton-polo-9044885.jpg?v=1776284592",
      "url": "/products/duncan-dot-performance-polo?variant=50703556116766",
      "variants": [
        {
          "id": "50703556116766",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 12500,
          "sku": "MTK0536-SKY-S"
        },
        {
          "id": "50703556149534",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 12500,
          "sku": "MTK0536-SKY-M"
        },
        {
          "id": "50703556182302",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 12500,
          "sku": "MTK0536-SKY-L"
        },
        {
          "id": "50703556215070",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 12500,
          "sku": "MTK0536-SKY-XL"
        },
        {
          "id": "50703556247838",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 12500,
          "sku": "MTK0536-SKY-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "tide-to-tee-pant--anchor": {
      "id": "tide-to-tee-pant--anchor",
      "productId": "tide-to-tee-pant",
      "handle": "tide-to-tee-pant",
      "title": "Tide to Tee Pant",
      "color": "Anchor",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 15000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/tide-to-tee-pant-1277832.jpg?v=1776284602",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/tide-to-tee-pant-1277832.jpg?v=1776284602",
      "url": "/products/tide-to-tee-pant?variant=50573800735006",
      "variants": [
        {
          "id": "50573800735006",
          "options": {
            "Size": "30",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-B0475-30"
        },
        {
          "id": "50573800767774",
          "options": {
            "Size": "32",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-B0475-32"
        },
        {
          "id": "50573800800542",
          "options": {
            "Size": "33",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-B0475-33"
        },
        {
          "id": "50573800833310",
          "options": {
            "Size": "34",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-B0475-34"
        },
        {
          "id": "50573800866078",
          "options": {
            "Size": "35",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-B0475-35"
        },
        {
          "id": "50573800898846",
          "options": {
            "Size": "36",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-B0475-36"
        },
        {
          "id": "50573800931614",
          "options": {
            "Size": "38",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-B0475-38"
        },
        {
          "id": "50573800964382",
          "options": {
            "Size": "40",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-B0475-40"
        },
        {
          "id": "50573800997150",
          "options": {
            "Size": "42",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-B0475-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "shadow-casual-shoes": {
      "id": "shadow-casual-shoes",
      "title": "White leather spikeless golf shoes",
      "color": "White",
      "ownership": "closet",
      "icon": "sneakers",
      "active": true
    },
    "market-sportshirt--white-shamrock": {
      "id": "market-sportshirt--white-shamrock",
      "productId": "market-sportshirt",
      "handle": "market-sportshirt",
      "title": "Market Cotton Sport Shirt",
      "color": "White/Shamrock",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 17500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/market-cotton-sport-shirt-5490492.jpg?v=1784635688",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/market-cotton-sport-shirt-5490492.jpg?v=1784635688",
      "url": "/products/market-sportshirt?variant=50078951604510",
      "variants": [
        {
          "id": "50078951604510",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0350-W0085-S"
        },
        {
          "id": "50078951637278",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0350-W0085-M"
        },
        {
          "id": "50078951670046",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0350-W0085-L"
        },
        {
          "id": "50078951702814",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0350-W0085-XL"
        },
        {
          "id": "50078951735582",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0350-W0085-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "ridge-sateen-pant--sage": {
      "id": "ridge-sateen-pant--sage",
      "productId": "ridge-sateen-pant",
      "handle": "ridge-sateen-pant",
      "title": "Ridge Sateen Pant",
      "color": "Sage",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 19000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-3789320.jpg?v=1786405334",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-3789320.jpg?v=1786405334",
      "url": "/products/ridge-sateen-pant?variant=59756547440926",
      "variants": [
        {
          "id": "59756547408158",
          "options": {
            "Size": "30",
            "Inseam": "30"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-30-30"
        },
        {
          "id": "59756547440926",
          "options": {
            "Size": "30",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-32-30"
        },
        {
          "id": "59756547473694",
          "options": {
            "Size": "30",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-34-30"
        },
        {
          "id": "59756547506462",
          "options": {
            "Size": "32",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-30-32"
        },
        {
          "id": "59756547539230",
          "options": {
            "Size": "32",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-32-32"
        },
        {
          "id": "59756547571998",
          "options": {
            "Size": "32",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-34-32"
        },
        {
          "id": "59756547604766",
          "options": {
            "Size": "33",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-30-33"
        },
        {
          "id": "59756547637534",
          "options": {
            "Size": "33",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-32-33"
        },
        {
          "id": "59756547670302",
          "options": {
            "Size": "33",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-34-33"
        },
        {
          "id": "59756547703070",
          "options": {
            "Size": "34",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-30-34"
        },
        {
          "id": "59756547735838",
          "options": {
            "Size": "34",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-32-34"
        },
        {
          "id": "59756547768606",
          "options": {
            "Size": "34",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-34-34"
        },
        {
          "id": "59756547801374",
          "options": {
            "Size": "35",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-30-35"
        },
        {
          "id": "59756547834142",
          "options": {
            "Size": "35",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-32-35"
        },
        {
          "id": "59756547866910",
          "options": {
            "Size": "35",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-34-35"
        },
        {
          "id": "59756547899678",
          "options": {
            "Size": "36",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-30-36"
        },
        {
          "id": "59756547932446",
          "options": {
            "Size": "36",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-32-36"
        },
        {
          "id": "59756547965214",
          "options": {
            "Size": "36",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-34-36"
        },
        {
          "id": "59756547997982",
          "options": {
            "Size": "38",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-30-38"
        },
        {
          "id": "59756548030750",
          "options": {
            "Size": "38",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-32-38"
        },
        {
          "id": "59756548063518",
          "options": {
            "Size": "38",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-34-38"
        },
        {
          "id": "59756548096286",
          "options": {
            "Size": "40",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-30-40"
        },
        {
          "id": "59756548129054",
          "options": {
            "Size": "40",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-32-40"
        },
        {
          "id": "59756548161822",
          "options": {
            "Size": "40",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-34-40"
        },
        {
          "id": "59756548194590",
          "options": {
            "Size": "42",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-30-42"
        },
        {
          "id": "59756548227358",
          "options": {
            "Size": "42",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-32-42"
        },
        {
          "id": "59756548260126",
          "options": {
            "Size": "42",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-G0198-34-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "shadow-shirt-shoes": {
      "id": "shadow-shirt-shoes",
      "title": "Tobacco suede loafers",
      "color": "Tobacco",
      "ownership": "closet",
      "icon": "loafers",
      "active": true
    },
    "atlantic-long-sleeve-pocket-tee--anchor": {
      "id": "atlantic-long-sleeve-pocket-tee--anchor",
      "productId": "atlantic-long-sleeve-pocket-tee",
      "handle": "atlantic-long-sleeve-pocket-tee",
      "title": "Atlantic Long Sleeve Pocket Tee",
      "color": "Anchor",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 7500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/atlantic-long-sleeve-pocket-tee-3116112.jpg?v=1776284533",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/atlantic-long-sleeve-pocket-tee-3116112.jpg?v=1776284533",
      "url": "/products/atlantic-long-sleeve-pocket-tee?variant=50789563531550",
      "variants": [
        {
          "id": "50789563531550",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-B0475-S"
        },
        {
          "id": "50789563564318",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-B0475-M"
        },
        {
          "id": "50789563597086",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-B0475-L"
        },
        {
          "id": "50789563629854",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-B0475-XL"
        },
        {
          "id": "50789563662622",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-B0475-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "lance-ultra-light-vest--pacific": {
      "id": "lance-ultra-light-vest--pacific",
      "productId": "lance-ultra-light-vest",
      "handle": "lance-ultra-light-vest",
      "title": "Lance Ultra-Light Vest",
      "color": "Pacific",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 20000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/lance-ultra-light-vest-7642885.jpg?v=1776284538",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/lance-ultra-light-vest-7642885.jpg?v=1776284538",
      "url": "/products/lance-ultra-light-vest?variant=50703560343838",
      "variants": [
        {
          "id": "50703560278302",
          "options": {
            "Size": "S"
          },
          "available": false,
          "priceCents": 20000,
          "sku": "MTO0464-B0480-S"
        },
        {
          "id": "50703560311070",
          "options": {
            "Size": "M"
          },
          "available": false,
          "priceCents": 20000,
          "sku": "MTO0464-B0480-M"
        },
        {
          "id": "50703560343838",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 20000,
          "sku": "MTO0464-B0480-L"
        },
        {
          "id": "50703560376606",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 20000,
          "sku": "MTO0464-B0480-XL"
        },
        {
          "id": "50703560409374",
          "options": {
            "Size": "2XL"
          },
          "available": false,
          "priceCents": 20000,
          "sku": "MTO0464-B0480-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "mbp0019-arthur-corduroy-5-pocket--stone": {
      "id": "mbp0019-arthur-corduroy-5-pocket--stone",
      "productId": "mbp0019-arthur-corduroy-5-pocket",
      "handle": "mbp0019-arthur-corduroy-5-pocket",
      "title": "Arthur Corduroy Pant",
      "color": "Stone",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 17500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/arthur-corduroy-pant-8750486.jpg?v=1776285612",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/arthur-corduroy-pant-8750486.jpg?v=1776285612",
      "url": "/products/mbp0019-arthur-corduroy-5-pocket?variant=49087115198750",
      "variants": [
        {
          "id": "49087115198750",
          "options": {
            "Size": "30"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-30"
        },
        {
          "id": "49087115231518",
          "options": {
            "Size": "32"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-32"
        },
        {
          "id": "49087115264286",
          "options": {
            "Size": "33"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-33"
        },
        {
          "id": "49087115297054",
          "options": {
            "Size": "34"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-34"
        },
        {
          "id": "49087115329822",
          "options": {
            "Size": "35"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-35"
        },
        {
          "id": "49087115362590",
          "options": {
            "Size": "36"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-36"
        },
        {
          "id": "49087115395358",
          "options": {
            "Size": "38"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-38"
        },
        {
          "id": "49087115428126",
          "options": {
            "Size": "40"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-40"
        },
        {
          "id": "49087115460894",
          "options": {
            "Size": "42"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-STON-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "shadow-jacket-shoes": {
      "id": "shadow-jacket-shoes",
      "title": "Dark brown leather Chelsea boots",
      "color": "Dark brown",
      "ownership": "closet",
      "icon": "boots",
      "active": true
    },
    "white": {
      "id": "white",
      "productId": "briggs-1-4-zip",
      "handle": "briggs-1-4-zip",
      "title": "Briggs Quarter Zip",
      "color": "White",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 13500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/briggs-quarter-zip-8636664.jpg?v=1786405213",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/briggs-quarter-zip-8636664.jpg?v=1786405213",
      "url": "/products/briggs-1-4-zip?variant=59756582273310",
      "variants": [
        {
          "id": "59756582273310",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-WHIT-S"
        },
        {
          "id": "59756582306078",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-WHIT-M"
        },
        {
          "id": "59756582338846",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-WHIT-L"
        },
        {
          "id": "59756582371614",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-WHIT-XL"
        },
        {
          "id": "59756582404382",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-WHIT-2XL"
        },
        {
          "id": "59756582437150",
          "options": {
            "Size": "3XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-WHIT-3XL"
        },
        {
          "id": "59756582469918",
          "options": {
            "Size": "4XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-WHIT-4XL"
        },
        {
          "id": "59756582502686",
          "options": {
            "Size": "5XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-WHIT-5XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "atlantic-short-sleeve-pocket-tee--anchor": {
      "id": "atlantic-short-sleeve-pocket-tee--anchor",
      "productId": "atlantic-short-sleeve-pocket-tee",
      "handle": "atlantic-short-sleeve-pocket-tee",
      "title": "Atlantic Short Sleeve Pocket Tee",
      "color": "Anchor",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 7000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/atlantic-short-sleeve-pocket-tee-1319989.jpg?v=1776284532",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/atlantic-short-sleeve-pocket-tee-1319989.jpg?v=1776284532",
      "url": "/products/atlantic-short-sleeve-pocket-tee?variant=50789562876190",
      "variants": [
        {
          "id": "50789562876190",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 7000,
          "sku": "MTK0555-B0475-S"
        },
        {
          "id": "50789562908958",
          "options": {
            "Size": "M"
          },
          "available": false,
          "priceCents": 7000,
          "sku": "MTK0555-B0475-M"
        },
        {
          "id": "50789562941726",
          "options": {
            "Size": "L"
          },
          "available": false,
          "priceCents": 7000,
          "sku": "MTK0555-B0475-L"
        },
        {
          "id": "50789562974494",
          "options": {
            "Size": "XL"
          },
          "available": false,
          "priceCents": 7000,
          "sku": "MTK0555-B0475-XL"
        },
        {
          "id": "50789563007262",
          "options": {
            "Size": "2XL"
          },
          "available": false,
          "priceCents": 7000,
          "sku": "MTK0555-B0475-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "tide-to-tee-short--pacific": {
      "id": "tide-to-tee-short--pacific",
      "productId": "tide-to-tee-short",
      "handle": "tide-to-tee-short",
      "title": "Tide to Tee Short",
      "color": "Pacific",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 12500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/tide-to-tee-short-1289126.jpg?v=1776284602",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/tide-to-tee-short-1289126.jpg?v=1776284602",
      "url": "/products/tide-to-tee-short?variant=50573801652510",
      "variants": [
        {
          "id": "50573801652510",
          "options": {
            "Size": "30"
          },
          "available": true,
          "priceCents": 12500,
          "sku": "MBZ0542-B0480-30"
        },
        {
          "id": "50573801685278",
          "options": {
            "Size": "32"
          },
          "available": true,
          "priceCents": 12500,
          "sku": "MBZ0542-B0480-32"
        },
        {
          "id": "50573801718046",
          "options": {
            "Size": "33"
          },
          "available": false,
          "priceCents": 12500,
          "sku": "MBZ0542-B0480-33"
        },
        {
          "id": "50573801750814",
          "options": {
            "Size": "34"
          },
          "available": true,
          "priceCents": 12500,
          "sku": "MBZ0542-B0480-34"
        },
        {
          "id": "50573801783582",
          "options": {
            "Size": "35"
          },
          "available": true,
          "priceCents": 12500,
          "sku": "MBZ0542-B0480-35"
        },
        {
          "id": "50573801816350",
          "options": {
            "Size": "36"
          },
          "available": true,
          "priceCents": 12500,
          "sku": "MBZ0542-B0480-36"
        },
        {
          "id": "50573801849118",
          "options": {
            "Size": "38"
          },
          "available": true,
          "priceCents": 12500,
          "sku": "MBZ0542-B0480-38"
        },
        {
          "id": "50573801881886",
          "options": {
            "Size": "40"
          },
          "available": true,
          "priceCents": 12500,
          "sku": "MBZ0542-B0480-40"
        },
        {
          "id": "50573801914654",
          "options": {
            "Size": "42"
          },
          "available": true,
          "priceCents": 12500,
          "sku": "MBZ0542-B0480-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "white-casual-shoes": {
      "id": "white-casual-shoes",
      "title": "Weathered gray suede sneakers",
      "color": "Stone gray",
      "ownership": "closet",
      "icon": "sneakers",
      "active": true
    },
    "bayview-twill-sport-shirt--anchor": {
      "id": "bayview-twill-sport-shirt--anchor",
      "productId": "bayview-twill-sport-shirt",
      "handle": "bayview-twill-sport-shirt",
      "title": "Bayview Twill Sport Shirt",
      "color": "ANCHOR",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 17500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/bayview-twill-sport-shirt-4981593.jpg?v=1786405231",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/bayview-twill-sport-shirt-4981593.jpg?v=1786405231",
      "url": "/products/bayview-twill-sport-shirt?variant=59756553011486",
      "variants": [
        {
          "id": "59756553011486",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0409-B0475-S"
        },
        {
          "id": "59756553044254",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0409-B0475-M"
        },
        {
          "id": "59756553077022",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0409-B0475-L"
        },
        {
          "id": "59756553109790",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0409-B0475-XL"
        },
        {
          "id": "59756553142558",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0409-B0475-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "ridge-sateen-pant--admiral": {
      "id": "ridge-sateen-pant--admiral",
      "productId": "ridge-sateen-pant",
      "handle": "ridge-sateen-pant",
      "title": "Ridge Sateen Pant",
      "color": "Admiral",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 19000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-5272052.jpg?v=1786405287",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-5272052.jpg?v=1786405287",
      "url": "/products/ridge-sateen-pant?variant=59756543901982",
      "variants": [
        {
          "id": "59756543869214",
          "options": {
            "Size": "30",
            "Inseam": "30"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-30"
        },
        {
          "id": "59756543901982",
          "options": {
            "Size": "30",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-30"
        },
        {
          "id": "59756543934750",
          "options": {
            "Size": "30",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-30"
        },
        {
          "id": "59756543967518",
          "options": {
            "Size": "32",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-32"
        },
        {
          "id": "59756544000286",
          "options": {
            "Size": "32",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-32"
        },
        {
          "id": "59756544033054",
          "options": {
            "Size": "32",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-32"
        },
        {
          "id": "59756544065822",
          "options": {
            "Size": "33",
            "Inseam": "30"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-33"
        },
        {
          "id": "59756544098590",
          "options": {
            "Size": "33",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-33"
        },
        {
          "id": "59756544131358",
          "options": {
            "Size": "33",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-33"
        },
        {
          "id": "59756544164126",
          "options": {
            "Size": "34",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-34"
        },
        {
          "id": "59756544196894",
          "options": {
            "Size": "34",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-34"
        },
        {
          "id": "59756544229662",
          "options": {
            "Size": "34",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-34"
        },
        {
          "id": "59756544262430",
          "options": {
            "Size": "35",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-35"
        },
        {
          "id": "59756544295198",
          "options": {
            "Size": "35",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-35"
        },
        {
          "id": "59756544327966",
          "options": {
            "Size": "35",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-35"
        },
        {
          "id": "59756544360734",
          "options": {
            "Size": "36",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-36"
        },
        {
          "id": "59756544393502",
          "options": {
            "Size": "36",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-36"
        },
        {
          "id": "59756544426270",
          "options": {
            "Size": "36",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-36"
        },
        {
          "id": "59756544459038",
          "options": {
            "Size": "38",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-38"
        },
        {
          "id": "59756544491806",
          "options": {
            "Size": "38",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-38"
        },
        {
          "id": "59756544524574",
          "options": {
            "Size": "38",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-38"
        },
        {
          "id": "59756544557342",
          "options": {
            "Size": "40",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-40"
        },
        {
          "id": "59756544590110",
          "options": {
            "Size": "40",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-40"
        },
        {
          "id": "59756544622878",
          "options": {
            "Size": "40",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-40"
        },
        {
          "id": "59756544655646",
          "options": {
            "Size": "42",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-30-42"
        },
        {
          "id": "59756544688414",
          "options": {
            "Size": "42",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-32-42"
        },
        {
          "id": "59756544721182",
          "options": {
            "Size": "42",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0051-34-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "white-shirt-shoes": {
      "id": "white-shirt-shoes",
      "title": "Chocolate leather loafers",
      "color": "Chocolate",
      "ownership": "closet",
      "icon": "loafers",
      "active": true
    },
    "grady-polo--blue-steel": {
      "id": "grady-polo--blue-steel",
      "productId": "grady-polo",
      "handle": "grady-polo",
      "title": "Grady Polo",
      "color": "Blue Steel",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 12000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTK0630_B0665.jpg?v=1786376852",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTK0630_B0665.jpg?v=1786376852",
      "url": "/products/grady-polo?variant=59738280001822",
      "variants": [
        {
          "id": "59738280001822",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0630-B0665-S"
        },
        {
          "id": "59738280034590",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0630-B0665-M"
        },
        {
          "id": "59738280067358",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0630-B0665-L"
        },
        {
          "id": "59738280100126",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0630-B0665-XL"
        },
        {
          "id": "59738280132894",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0630-B0665-2XL"
        },
        {
          "id": "59738280165662",
          "options": {
            "Size": "3XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0630-B0665-3XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "essex-suede-vest--blue-steel": {
      "id": "essex-suede-vest--blue-steel",
      "productId": "essex-suede-vest",
      "handle": "essex-suede-vest",
      "title": "Essex Suede Vest",
      "color": "BLUE STEEL",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 69500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/essex-suede-vest-9509229.jpg?v=1786405220",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/essex-suede-vest-9509229.jpg?v=1786405220",
      "url": "/products/essex-suede-vest?variant=59756561727774",
      "variants": [
        {
          "id": "59756561727774",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 69500,
          "sku": "MTO0027-B0665-S"
        },
        {
          "id": "59756561760542",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 69500,
          "sku": "MTO0027-B0665-M"
        },
        {
          "id": "59756561793310",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 69500,
          "sku": "MTO0027-B0665-L"
        },
        {
          "id": "59756561826078",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 69500,
          "sku": "MTO0027-B0665-XL"
        },
        {
          "id": "59756561858846",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 69500,
          "sku": "MTO0027-B0665-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "bristol-brushed-twill-hybrid-5-pocket--navy": {
      "id": "bristol-brushed-twill-hybrid-5-pocket--navy",
      "productId": "bristol-brushed-twill-hybrid-5-pocket",
      "handle": "bristol-brushed-twill-hybrid-5-pocket",
      "title": "Bristol Twill Hybrid 5-Pocket Pant",
      "color": "Navy",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 13500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/bristol-twill-hybrid-5-pocket-pant-2134012.jpg?v=1789638308",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/bristol-twill-hybrid-5-pocket-pant-2134012.jpg?v=1789638308",
      "url": "/products/bristol-brushed-twill-hybrid-5-pocket?variant=12551735083096",
      "variants": [
        {
          "id": "12551735083096",
          "options": {
            "Size": "32"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-32"
        },
        {
          "id": "12551735115864",
          "options": {
            "Size": "33"
          },
          "available": false,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-33"
        },
        {
          "id": "12551735148632",
          "options": {
            "Size": "34"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-34"
        },
        {
          "id": "12551735181400",
          "options": {
            "Size": "35"
          },
          "available": false,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-35"
        },
        {
          "id": "12551735214168",
          "options": {
            "Size": "36"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-36"
        },
        {
          "id": "12551735246936",
          "options": {
            "Size": "38"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-38"
        },
        {
          "id": "12551735279704",
          "options": {
            "Size": "40"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-40"
        },
        {
          "id": "12551735312472",
          "options": {
            "Size": "42"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MF18P01-NAVY-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "white-jacket-shoes": {
      "id": "white-jacket-shoes",
      "title": "Snuff suede Chelsea boots",
      "color": "Snuff brown",
      "ownership": "closet",
      "icon": "boots",
      "active": true
    },
    "academy": {
      "id": "academy",
      "productId": "briggs-1-4-zip",
      "handle": "briggs-1-4-zip",
      "title": "Briggs Quarter Zip",
      "color": "Academy",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 13500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/briggs-quarter-zip-6165588.jpg?v=1786405213",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/briggs-quarter-zip-6165588.jpg?v=1786405213",
      "url": "/products/briggs-1-4-zip?variant=59756582568222",
      "variants": [
        {
          "id": "59756582535454",
          "options": {
            "Size": "S"
          },
          "available": false,
          "priceCents": 13500,
          "sku": "MTL0643-B0646-S"
        },
        {
          "id": "59756582568222",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-B0646-M"
        },
        {
          "id": "59756582600990",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-B0646-L"
        },
        {
          "id": "59756582633758",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-B0646-XL"
        },
        {
          "id": "59756582666526",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-B0646-2XL"
        },
        {
          "id": "59756582699294",
          "options": {
            "Size": "3XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-B0646-3XL"
        },
        {
          "id": "59756582732062",
          "options": {
            "Size": "4XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-B0646-4XL"
        },
        {
          "id": "59756582764830",
          "options": {
            "Size": "5XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-B0646-5XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "grady-polo--sage": {
      "id": "grady-polo--sage",
      "productId": "grady-polo",
      "handle": "grady-polo",
      "title": "Grady Polo",
      "color": "Sage",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 12000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTK0630_G0198.jpg?v=1786376852",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTK0630_G0198.jpg?v=1786376852",
      "url": "/products/grady-polo?variant=59738279805214",
      "variants": [
        {
          "id": "59738279805214",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0630-G0198-S"
        },
        {
          "id": "59738279837982",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0630-G0198-M"
        },
        {
          "id": "59738279870750",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0630-G0198-L"
        },
        {
          "id": "59738279903518",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0630-G0198-XL"
        },
        {
          "id": "59738279936286",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0630-G0198-2XL"
        },
        {
          "id": "59738279969054",
          "options": {
            "Size": "3XL"
          },
          "available": true,
          "priceCents": 12000,
          "sku": "MTK0630-G0198-3XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "tide-to-tee-pant--almond": {
      "id": "tide-to-tee-pant--almond",
      "productId": "tide-to-tee-pant",
      "handle": "tide-to-tee-pant",
      "title": "Tide to Tee Pant",
      "color": "Almond",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 15000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/tide-to-tee-pant-6234672.jpg?v=1776284600",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/tide-to-tee-pant-6234672.jpg?v=1776284600",
      "url": "/products/tide-to-tee-pant?variant=50573801029918",
      "variants": [
        {
          "id": "50573801029918",
          "options": {
            "Size": "30",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-IOO22-30"
        },
        {
          "id": "50573801062686",
          "options": {
            "Size": "32",
            "Inseam": "34"
          },
          "available": false,
          "priceCents": 15000,
          "sku": "MBP0541-IOO22-32"
        },
        {
          "id": "50573801095454",
          "options": {
            "Size": "33",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-IOO22-33"
        },
        {
          "id": "50573801128222",
          "options": {
            "Size": "34",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-IOO22-34"
        },
        {
          "id": "50573801160990",
          "options": {
            "Size": "35",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-IOO22-35"
        },
        {
          "id": "50573801193758",
          "options": {
            "Size": "36",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-IOO22-36"
        },
        {
          "id": "50573801226526",
          "options": {
            "Size": "38",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-IOO22-38"
        },
        {
          "id": "50573801259294",
          "options": {
            "Size": "40",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-IOO22-40"
        },
        {
          "id": "50573801292062",
          "options": {
            "Size": "42",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 15000,
          "sku": "MBP0541-IOO22-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "academy-casual-shoes": {
      "id": "academy-casual-shoes",
      "title": "Sand and white spikeless golf shoes",
      "color": "Sand / white",
      "ownership": "closet",
      "icon": "sneakers",
      "active": true
    },
    "gunnar-sportshirt--thistle": {
      "id": "gunnar-sportshirt--thistle",
      "productId": "gunnar-sportshirt",
      "handle": "gunnar-sportshirt",
      "title": "Gunnar Cotton Sport Shirt",
      "color": "Thistle",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 17500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/gunnar-cotton-sport-shirt-6042795.jpg?v=1784635690",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/gunnar-cotton-sport-shirt-6042795.jpg?v=1784635690",
      "url": "/products/gunnar-sportshirt?variant=50078949081374",
      "variants": [
        {
          "id": "50078949081374",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0348-THIS-S"
        },
        {
          "id": "50078949114142",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0348-THIS-M"
        },
        {
          "id": "50078949146910",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0348-THIS-L"
        },
        {
          "id": "50078949179678",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0348-THIS-XL"
        },
        {
          "id": "50078949212446",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MTW0348-THIS-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "ridge-sateen-pant--khaki": {
      "id": "ridge-sateen-pant--khaki",
      "productId": "ridge-sateen-pant",
      "handle": "ridge-sateen-pant",
      "title": "Ridge Sateen Pant",
      "color": "Khaki",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 19000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-7487066.jpg?v=1786405334",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-7487066.jpg?v=1786405334",
      "url": "/products/ridge-sateen-pant?variant=59756546556190",
      "variants": [
        {
          "id": "59756546523422",
          "options": {
            "Size": "30",
            "Inseam": "30"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-30"
        },
        {
          "id": "59756546556190",
          "options": {
            "Size": "30",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-30"
        },
        {
          "id": "59756546588958",
          "options": {
            "Size": "30",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-30"
        },
        {
          "id": "59756546621726",
          "options": {
            "Size": "32",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-32"
        },
        {
          "id": "59756546654494",
          "options": {
            "Size": "32",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-32"
        },
        {
          "id": "59756546687262",
          "options": {
            "Size": "32",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-32"
        },
        {
          "id": "59756546720030",
          "options": {
            "Size": "33",
            "Inseam": "30"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-33"
        },
        {
          "id": "59756546752798",
          "options": {
            "Size": "33",
            "Inseam": "32"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-33"
        },
        {
          "id": "59756546785566",
          "options": {
            "Size": "33",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-33"
        },
        {
          "id": "59756546818334",
          "options": {
            "Size": "34",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-34"
        },
        {
          "id": "59756546851102",
          "options": {
            "Size": "34",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-34"
        },
        {
          "id": "59756546883870",
          "options": {
            "Size": "34",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-34"
        },
        {
          "id": "59756546916638",
          "options": {
            "Size": "35",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-35"
        },
        {
          "id": "59756546949406",
          "options": {
            "Size": "35",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-35"
        },
        {
          "id": "59756546982174",
          "options": {
            "Size": "35",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-35"
        },
        {
          "id": "59756547014942",
          "options": {
            "Size": "36",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-36"
        },
        {
          "id": "59756547047710",
          "options": {
            "Size": "36",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-36"
        },
        {
          "id": "59756547080478",
          "options": {
            "Size": "36",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-36"
        },
        {
          "id": "59756547113246",
          "options": {
            "Size": "38",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-38"
        },
        {
          "id": "59756547146014",
          "options": {
            "Size": "38",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-38"
        },
        {
          "id": "59756547178782",
          "options": {
            "Size": "38",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-38"
        },
        {
          "id": "59756547211550",
          "options": {
            "Size": "40",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-40"
        },
        {
          "id": "59756547244318",
          "options": {
            "Size": "40",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-40"
        },
        {
          "id": "59756547277086",
          "options": {
            "Size": "40",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-40"
        },
        {
          "id": "59756547309854",
          "options": {
            "Size": "42",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-30-42"
        },
        {
          "id": "59756547342622",
          "options": {
            "Size": "42",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-32-42"
        },
        {
          "id": "59756547375390",
          "options": {
            "Size": "42",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-KHAK-34-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "academy-shirt-shoes": {
      "id": "academy-shirt-shoes",
      "title": "Dark brown leather penny loafers",
      "color": "Dark brown",
      "ownership": "closet",
      "icon": "loafers",
      "active": true
    },
    "atlantic-long-sleeve-pocket-tee--pearl-heather": {
      "id": "atlantic-long-sleeve-pocket-tee--pearl-heather",
      "productId": "atlantic-long-sleeve-pocket-tee",
      "handle": "atlantic-long-sleeve-pocket-tee",
      "title": "Atlantic Long Sleeve Pocket Tee",
      "color": "Pearl Heather",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 7500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/atlantic-long-sleeve-pocket-tee-4324377.jpg?v=1776284534",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/atlantic-long-sleeve-pocket-tee-4324377.jpg?v=1776284534",
      "url": "/products/atlantic-long-sleeve-pocket-tee?variant=50789563859230",
      "variants": [
        {
          "id": "50789563859230",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-E0013-S"
        },
        {
          "id": "50789563891998",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-E0013-M"
        },
        {
          "id": "50789563924766",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-E0013-L"
        },
        {
          "id": "50789563957534",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-E0013-XL"
        },
        {
          "id": "50789563990302",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-E0013-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "cedar-waxed-suede-vest--taupe": {
      "id": "cedar-waxed-suede-vest--taupe",
      "productId": "cedar-waxed-suede-vest",
      "handle": "cedar-waxed-suede-vest",
      "title": "Cedar Waxed Suede Vest",
      "color": "TAUPE",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 69500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/cedar-waxed-suede-vest-3639561.jpg?v=1786405220",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/cedar-waxed-suede-vest-3639561.jpg?v=1786405220",
      "url": "/products/cedar-waxed-suede-vest?variant=59756561891614",
      "variants": [
        {
          "id": "59756561891614",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 69500,
          "sku": "MTO0014-N0027-S"
        },
        {
          "id": "59756561924382",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 69500,
          "sku": "MTO0014-N0027-M"
        },
        {
          "id": "59756561957150",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 69500,
          "sku": "MTO0014-N0027-L"
        },
        {
          "id": "59756561989918",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 69500,
          "sku": "MTO0014-N0027-XL"
        },
        {
          "id": "59756562022686",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 69500,
          "sku": "MTO0014-N0027-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "ridge-sateen-pant--shadow": {
      "id": "ridge-sateen-pant--shadow",
      "productId": "ridge-sateen-pant",
      "handle": "ridge-sateen-pant",
      "title": "Ridge Sateen Pant",
      "color": "Shadow",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 19000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-1923946.jpg?v=1786405286",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-1923946.jpg?v=1786405286",
      "url": "/products/ridge-sateen-pant?variant=59756544786718",
      "variants": [
        {
          "id": "59756544753950",
          "options": {
            "Size": "30",
            "Inseam": "30"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-30-30"
        },
        {
          "id": "59756544786718",
          "options": {
            "Size": "30",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-32-30"
        },
        {
          "id": "59756544819486",
          "options": {
            "Size": "30",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-34-30"
        },
        {
          "id": "59756544852254",
          "options": {
            "Size": "32",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-30-32"
        },
        {
          "id": "59756544885022",
          "options": {
            "Size": "32",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-32-32"
        },
        {
          "id": "59756544917790",
          "options": {
            "Size": "32",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-34-32"
        },
        {
          "id": "59756544950558",
          "options": {
            "Size": "33",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-30-33"
        },
        {
          "id": "59756544983326",
          "options": {
            "Size": "33",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-32-33"
        },
        {
          "id": "59756545016094",
          "options": {
            "Size": "33",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-34-33"
        },
        {
          "id": "59756545048862",
          "options": {
            "Size": "34",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-30-34"
        },
        {
          "id": "59756545081630",
          "options": {
            "Size": "34",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-32-34"
        },
        {
          "id": "59756545114398",
          "options": {
            "Size": "34",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-34-34"
        },
        {
          "id": "59756545147166",
          "options": {
            "Size": "35",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-30-35"
        },
        {
          "id": "59756545179934",
          "options": {
            "Size": "35",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-32-35"
        },
        {
          "id": "59756545212702",
          "options": {
            "Size": "35",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-34-35"
        },
        {
          "id": "59756545245470",
          "options": {
            "Size": "36",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-30-36"
        },
        {
          "id": "59756545278238",
          "options": {
            "Size": "36",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-32-36"
        },
        {
          "id": "59756545311006",
          "options": {
            "Size": "36",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-34-36"
        },
        {
          "id": "59756545343774",
          "options": {
            "Size": "38",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-30-38"
        },
        {
          "id": "59756545376542",
          "options": {
            "Size": "38",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-32-38"
        },
        {
          "id": "59756545409310",
          "options": {
            "Size": "38",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-34-38"
        },
        {
          "id": "59756545442078",
          "options": {
            "Size": "40",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-30-40"
        },
        {
          "id": "59756545474846",
          "options": {
            "Size": "40",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-32-40"
        },
        {
          "id": "59756545507614",
          "options": {
            "Size": "40",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-34-40"
        },
        {
          "id": "59756545540382",
          "options": {
            "Size": "42",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-30-42"
        },
        {
          "id": "59756545573150",
          "options": {
            "Size": "42",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-32-42"
        },
        {
          "id": "59756545605918",
          "options": {
            "Size": "42",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-E0016-34-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "academy-jacket-shoes": {
      "id": "academy-jacket-shoes",
      "title": "Chocolate suede loafers",
      "color": "Chocolate",
      "ownership": "closet",
      "icon": "loafers",
      "active": true
    },
    "black": {
      "id": "black",
      "productId": "briggs-1-4-zip",
      "handle": "briggs-1-4-zip",
      "title": "Briggs Quarter Zip",
      "color": "Black",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 13500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/briggs-quarter-zip-1946345.jpg?v=1786405213",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/briggs-quarter-zip-1946345.jpg?v=1786405213",
      "url": "/products/briggs-1-4-zip?variant=59756582797598",
      "variants": [
        {
          "id": "59756582797598",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-BLAC-S"
        },
        {
          "id": "59756582830366",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-BLAC-M"
        },
        {
          "id": "59756582863134",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-BLAC-L"
        },
        {
          "id": "59756582895902",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-BLAC-XL"
        },
        {
          "id": "59756582928670",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-BLAC-2XL"
        },
        {
          "id": "59756582961438",
          "options": {
            "Size": "3XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-BLAC-3XL"
        },
        {
          "id": "59756582994206",
          "options": {
            "Size": "4XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-BLAC-4XL"
        },
        {
          "id": "59756583026974",
          "options": {
            "Size": "5XL"
          },
          "available": true,
          "priceCents": 13500,
          "sku": "MTL0643-BLAC-5XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "atlantic-long-sleeve-pocket-tee--soft-sky": {
      "id": "atlantic-long-sleeve-pocket-tee--soft-sky",
      "productId": "atlantic-long-sleeve-pocket-tee",
      "handle": "atlantic-long-sleeve-pocket-tee",
      "title": "Atlantic Long Sleeve Pocket Tee",
      "color": "Soft Sky",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 7500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/atlantic-long-sleeve-pocket-tee-4892280.jpg?v=1776284534",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/atlantic-long-sleeve-pocket-tee-4892280.jpg?v=1776284534",
      "url": "/products/atlantic-long-sleeve-pocket-tee?variant=50789563695390",
      "variants": [
        {
          "id": "50789563695390",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-B0479-S"
        },
        {
          "id": "50789563728158",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-B0479-M"
        },
        {
          "id": "50789563760926",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-B0479-L"
        },
        {
          "id": "50789563793694",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-B0479-XL"
        },
        {
          "id": "50789563826462",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 7500,
          "sku": "MTK0556-B0479-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "black-casual-jeans": {
      "id": "black-casual-jeans",
      "title": "Your washed gray jeans",
      "color": "Washed gray",
      "ownership": "closet",
      "isDenim": true,
      "fromYourCloset": true,
      "icon": "denim",
      "active": true
    },
    "black-casual-shoes": {
      "id": "black-casual-shoes",
      "title": "Off-white leather low-top sneakers",
      "color": "Off-white",
      "ownership": "closet",
      "icon": "sneakers",
      "active": true
    },
    "nells-button-front--anchor-blue-steel": {
      "id": "nells-button-front--anchor-blue-steel",
      "productId": "nells-button-front",
      "handle": "nells-button-front",
      "title": "Nells Jacquard Button Front",
      "color": "ANCHOR / BLUE STEEL",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 18000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/nells-jacquard-button-front-5613750.jpg?v=1786405221",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/nells-jacquard-button-front-5613750.jpg?v=1786405221",
      "url": "/products/nells-button-front?variant=59756566479134",
      "variants": [
        {
          "id": "59756566479134",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 18000,
          "sku": "MTK0858-B0685-S"
        },
        {
          "id": "59756566511902",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 18000,
          "sku": "MTK0858-B0685-M"
        },
        {
          "id": "59756566544670",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 18000,
          "sku": "MTK0858-B0685-L"
        },
        {
          "id": "59756566577438",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 18000,
          "sku": "MTK0858-B0685-XL"
        },
        {
          "id": "59756566610206",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 18000,
          "sku": "MTK0858-B0685-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "ridge-sateen-pant--blue-steel": {
      "id": "ridge-sateen-pant--blue-steel",
      "productId": "ridge-sateen-pant",
      "handle": "ridge-sateen-pant",
      "title": "Ridge Sateen Pant",
      "color": "Blue Steel",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 19000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-7345844.jpg?v=1786405286",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/ridge-sateen-pant-7345844.jpg?v=1786405286",
      "url": "/products/ridge-sateen-pant?variant=59756543017246",
      "variants": [
        {
          "id": "59756542984478",
          "options": {
            "Size": "30",
            "Inseam": "30"
          },
          "available": false,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-30-30"
        },
        {
          "id": "59756543017246",
          "options": {
            "Size": "30",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-32-30"
        },
        {
          "id": "59756543050014",
          "options": {
            "Size": "30",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-34-30"
        },
        {
          "id": "59756543082782",
          "options": {
            "Size": "32",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-30-32"
        },
        {
          "id": "59756543115550",
          "options": {
            "Size": "32",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-32-32"
        },
        {
          "id": "59756543148318",
          "options": {
            "Size": "32",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-34-32"
        },
        {
          "id": "59756543181086",
          "options": {
            "Size": "33",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-30-33"
        },
        {
          "id": "59756543213854",
          "options": {
            "Size": "33",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-32-33"
        },
        {
          "id": "59756543246622",
          "options": {
            "Size": "33",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-34-33"
        },
        {
          "id": "59756543279390",
          "options": {
            "Size": "34",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-30-34"
        },
        {
          "id": "59756543312158",
          "options": {
            "Size": "34",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-32-34"
        },
        {
          "id": "59756543344926",
          "options": {
            "Size": "34",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-34-34"
        },
        {
          "id": "59756543377694",
          "options": {
            "Size": "35",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-30-35"
        },
        {
          "id": "59756543410462",
          "options": {
            "Size": "35",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-32-35"
        },
        {
          "id": "59756543443230",
          "options": {
            "Size": "35",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-34-35"
        },
        {
          "id": "59756543475998",
          "options": {
            "Size": "36",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-30-36"
        },
        {
          "id": "59756543508766",
          "options": {
            "Size": "36",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-32-36"
        },
        {
          "id": "59756543541534",
          "options": {
            "Size": "36",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-34-36"
        },
        {
          "id": "59756543574302",
          "options": {
            "Size": "38",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-30-38"
        },
        {
          "id": "59756543607070",
          "options": {
            "Size": "38",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-32-38"
        },
        {
          "id": "59756543639838",
          "options": {
            "Size": "38",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-34-38"
        },
        {
          "id": "59756543672606",
          "options": {
            "Size": "40",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-30-40"
        },
        {
          "id": "59756543705374",
          "options": {
            "Size": "40",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-32-40"
        },
        {
          "id": "59756543738142",
          "options": {
            "Size": "40",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-34-40"
        },
        {
          "id": "59756543770910",
          "options": {
            "Size": "42",
            "Inseam": "30"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-30-42"
        },
        {
          "id": "59756543803678",
          "options": {
            "Size": "42",
            "Inseam": "32"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-32-42"
        },
        {
          "id": "59756543836446",
          "options": {
            "Size": "42",
            "Inseam": "34"
          },
          "available": true,
          "priceCents": 19000,
          "sku": "MBP0763-B0665-34-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "black-shirt-shoes": {
      "id": "black-shirt-shoes",
      "title": "Tobacco suede loafers",
      "color": "Tobacco",
      "ownership": "closet",
      "icon": "loafers",
      "active": true
    },
    "beau-polo--black": {
      "id": "beau-polo--black",
      "productId": "beau-polo",
      "handle": "beau-polo",
      "title": "Beau Polo",
      "color": "Black",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 11000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTK0423_BLAC_d8d87aa5-40b7-448c-900c-afc6d92ae65d.jpg?v=1786376863",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/MTK0423_BLAC_d8d87aa5-40b7-448c-900c-afc6d92ae65d.jpg?v=1786376863",
      "url": "/products/beau-polo?variant=59738285637918",
      "variants": [
        {
          "id": "59738285637918",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 11000,
          "sku": "MTK0423-BLAC-S"
        },
        {
          "id": "59738285670686",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 11000,
          "sku": "MTK0423-BLAC-M"
        },
        {
          "id": "59738285703454",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 11000,
          "sku": "MTK0423-BLAC-L"
        },
        {
          "id": "59738285736222",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 11000,
          "sku": "MTK0423-BLAC-XL"
        },
        {
          "id": "59738285768990",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 11000,
          "sku": "MTK0423-BLAC-2XL"
        },
        {
          "id": "59738285801758",
          "options": {
            "Size": "3XL"
          },
          "available": true,
          "priceCents": 11000,
          "sku": "MTK0423-BLAC-3XL"
        },
        {
          "id": "59738285834526",
          "options": {
            "Size": "4XL"
          },
          "available": true,
          "priceCents": 11000,
          "sku": "MTK0423-BLAC-4XL"
        },
        {
          "id": "59738285867294",
          "options": {
            "Size": "5XL"
          },
          "available": true,
          "priceCents": 11000,
          "sku": "MTK0423-BLAC-5XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "wise-full-zip-vest--shadow-heather": {
      "id": "wise-full-zip-vest--shadow-heather",
      "productId": "wise-full-zip-vest",
      "handle": "wise-full-zip-vest",
      "title": "Wise Full Zip Vest",
      "color": "SHADOW HEATHER",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 21000,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/wise-full-zip-vest-1387983.jpg?v=1786405222",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/wise-full-zip-vest-1387983.jpg?v=1786405222",
      "url": "/products/wise-full-zip-vest?variant=59756559761694",
      "variants": [
        {
          "id": "59756559761694",
          "options": {
            "Size": "S"
          },
          "available": true,
          "priceCents": 21000,
          "sku": "MTS0408-E0027-S"
        },
        {
          "id": "59756559794462",
          "options": {
            "Size": "M"
          },
          "available": true,
          "priceCents": 21000,
          "sku": "MTS0408-E0027-M"
        },
        {
          "id": "59756559827230",
          "options": {
            "Size": "L"
          },
          "available": true,
          "priceCents": 21000,
          "sku": "MTS0408-E0027-L"
        },
        {
          "id": "59756559859998",
          "options": {
            "Size": "XL"
          },
          "available": true,
          "priceCents": 21000,
          "sku": "MTS0408-E0027-XL"
        },
        {
          "id": "59756559892766",
          "options": {
            "Size": "2XL"
          },
          "available": true,
          "priceCents": 21000,
          "sku": "MTS0408-E0027-2XL"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "mbp0019-arthur-corduroy-5-pocket--khaki": {
      "id": "mbp0019-arthur-corduroy-5-pocket--khaki",
      "productId": "mbp0019-arthur-corduroy-5-pocket",
      "handle": "mbp0019-arthur-corduroy-5-pocket",
      "title": "Arthur Corduroy Pant",
      "color": "Khaki",
      "ownership": "turtleson",
      "active": true,
      "licensed": false,
      "verified": true,
      "currency": "USD",
      "priceCents": 17500,
      "image": "https://cdn.shopify.com/s/files/1/1562/0273/files/arthur-corduroy-pant-3335079.jpg?v=1776285557",
      "sourceImage": "https://cdn.shopify.com/s/files/1/1562/0273/files/arthur-corduroy-pant-3335079.jpg?v=1776285557",
      "url": "/products/mbp0019-arthur-corduroy-5-pocket?variant=49087114936606",
      "variants": [
        {
          "id": "49087114936606",
          "options": {
            "Size": "30"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-KHAK-30"
        },
        {
          "id": "49087114969374",
          "options": {
            "Size": "32"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-KHAK-32"
        },
        {
          "id": "49087115002142",
          "options": {
            "Size": "33"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-KHAK-33"
        },
        {
          "id": "49087115034910",
          "options": {
            "Size": "34"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-KHAK-34"
        },
        {
          "id": "49087115067678",
          "options": {
            "Size": "35"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-KHAK-35"
        },
        {
          "id": "49087115100446",
          "options": {
            "Size": "36"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-KHAK-36"
        },
        {
          "id": "49087115133214",
          "options": {
            "Size": "38"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-KHAK-38"
        },
        {
          "id": "49087115165982",
          "options": {
            "Size": "42"
          },
          "available": true,
          "priceCents": 17500,
          "sku": "MBP0019-KHAK-42"
        }
      ],
      "verifiedAt": "2026-10-08"
    },
    "black-jacket-shoes": {
      "id": "black-jacket-shoes",
      "title": "Dark brown leather Chelsea boots",
      "color": "Dark brown",
      "ownership": "closet",
      "icon": "boots",
      "active": true
    }
  },
  "products": {
    "briggs-1-4-zip": {
      "id": "briggs-1-4-zip",
      "title": "Briggs Quarter Zip",
      "active": true,
      "licensed": false,
      "isLayer": true,
      "enabled": true,
      "colors": [
        "Shadow",
        "White",
        "Academy",
        "Black"
      ],
      "anchorItems": {
        "Shadow": "shadow",
        "White": "white",
        "Academy": "academy",
        "Black": "black"
      }
    }
  }
};
const looks = [
  {
    "id": "shadow-casual",
    "productId": "briggs-1-4-zip",
    "color": "Shadow",
    "title": "Ready for the morning tee time",
    "image": "assets/wl-briggs-1-4-zip-shadow-casual-v1.jpg",
    "pieces": {
      "underlayer": "duncan-dot-performance-polo--sky",
      "outerlayer": null,
      "pants": "tide-to-tee-pant--anchor",
      "shoes": "shadow-casual-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "A Sky polo brings a clean collar to the soft charcoal-gray terry. Anchor Tide to Tee Pant and white leather spikeless golf shoes complete a fresh look for the course.",
    "alt": "Shadow Briggs Quarter Zip styled with Duncan Dot Cotton Polo in Sky, Tide to Tee Pant in Anchor, White leather spikeless golf shoes in White. Head cropped out; shoes visible.",
    "tier": "Golf"
  },
  {
    "id": "shadow-shirt",
    "productId": "briggs-1-4-zip",
    "color": "Shadow",
    "title": "A polished casual office layer",
    "image": "assets/wl-briggs-1-4-zip-shadow-shirt-v1.jpg",
    "pieces": {
      "underlayer": "market-sportshirt--white-shamrock",
      "outerlayer": null,
      "pants": "ridge-sateen-pant--sage",
      "shoes": "shadow-shirt-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "The White/Shamrock Market Cotton Sport Shirt adds a crisp collar beneath the soft charcoal-gray terry. Sage Ridge Sateen Pant and tobacco suede loafers give this casual office look a polished finish.",
    "alt": "Shadow Briggs Quarter Zip styled with Market Cotton Sport Shirt in White/Shamrock, Ridge Sateen Pant in Sage, Tobacco suede loafers in Tobacco. Head cropped out; shoes visible.",
    "tier": "Polished"
  },
  {
    "id": "shadow-jacket",
    "productId": "briggs-1-4-zip",
    "color": "Shadow",
    "title": "A considered dinner layer",
    "image": "assets/wl-briggs-1-4-zip-shadow-jacket-v1.jpg",
    "pieces": {
      "underlayer": "atlantic-long-sleeve-pocket-tee--anchor",
      "outerlayer": "lance-ultra-light-vest--pacific",
      "pants": "mbp0019-arthur-corduroy-5-pocket--stone",
      "shoes": "shadow-jacket-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "Pacific Lance Ultra-Light Vest adds tactile depth over the soft charcoal-gray terry. Anchor Atlantic Long Sleeve Pocket Tee, Stone Arthur Corduroy Pant, and dark brown leather chelsea boots make the palette dinner-ready.",
    "alt": "Shadow Briggs Quarter Zip styled with Atlantic Long Sleeve Pocket Tee in Anchor, Lance Ultra-Light Vest in Pacific, Arthur Corduroy Pant in Stone, Dark brown leather Chelsea boots in Dark brown. Head cropped out; shoes visible.",
    "tier": "Refined"
  },
  {
    "id": "white-casual",
    "productId": "briggs-1-4-zip",
    "color": "White",
    "title": "Off-duty color, considered",
    "image": "assets/wl-briggs-1-4-zip-white-casual-v1.jpg",
    "pieces": {
      "underlayer": "atlantic-short-sleeve-pocket-tee--anchor",
      "outerlayer": null,
      "pants": "tide-to-tee-short--pacific",
      "shoes": "white-casual-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "An Anchor tee keeps the clean white terry relaxed; Pacific Tide to Tee Short and weathered gray suede sneakers make it easy for a weekend afternoon.",
    "alt": "White Briggs Quarter Zip styled with Atlantic Short Sleeve Pocket Tee in Anchor, Tide to Tee Short in Pacific, Weathered gray suede sneakers in Stone gray. Head cropped out; shoes visible.",
    "tier": "Casual"
  },
  {
    "id": "white-shirt",
    "productId": "briggs-1-4-zip",
    "color": "White",
    "title": "Texture for the workday",
    "image": "assets/wl-briggs-1-4-zip-white-shirt-v1.jpg",
    "pieces": {
      "underlayer": "bayview-twill-sport-shirt--anchor",
      "outerlayer": null,
      "pants": "ridge-sateen-pant--admiral",
      "shoes": "white-shirt-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "The ANCHOR Bayview Twill Sport Shirt adds a crisp collar beneath the clean white terry. Admiral Ridge Sateen Pant and chocolate leather loafers give this casual office look a polished finish.",
    "alt": "White Briggs Quarter Zip styled with Bayview Twill Sport Shirt in ANCHOR, Ridge Sateen Pant in Admiral, Chocolate leather loafers in Chocolate. Head cropped out; shoes visible.",
    "tier": "Polished"
  },
  {
    "id": "white-jacket",
    "productId": "briggs-1-4-zip",
    "color": "White",
    "title": "Quiet texture after hours",
    "image": "assets/wl-briggs-1-4-zip-white-jacket-v1.jpg",
    "pieces": {
      "underlayer": "grady-polo--blue-steel",
      "outerlayer": "essex-suede-vest--blue-steel",
      "pants": "bristol-brushed-twill-hybrid-5-pocket--navy",
      "shoes": "white-jacket-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "Blue Steel Essex Suede Vest adds tactile depth over the clean white terry. Blue Steel Grady Polo, Navy Bristol Twill Hybrid 5-Pocket Pant, and snuff suede chelsea boots make the palette dinner-ready.",
    "alt": "White Briggs Quarter Zip styled with Grady Polo in Blue Steel, Essex Suede Vest in BLUE STEEL, Bristol Twill Hybrid 5-Pocket Pant in Navy, Snuff suede Chelsea boots in Snuff brown. Head cropped out; shoes visible.",
    "tier": "Refined"
  },
  {
    "id": "academy-casual",
    "productId": "briggs-1-4-zip",
    "color": "Academy",
    "title": "A fresh take on course dressing",
    "image": "assets/wl-briggs-1-4-zip-academy-casual-v1.jpg",
    "pieces": {
      "underlayer": "grady-polo--sage",
      "outerlayer": null,
      "pants": "tide-to-tee-pant--almond",
      "shoes": "academy-casual-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "A Sage polo brings a clean collar to the dark Academy blue terry. Almond Tide to Tee Pant and sand and white spikeless golf shoes complete a fresh look for the course.",
    "alt": "Academy Briggs Quarter Zip styled with Grady Polo in Sage, Tide to Tee Pant in Almond, Sand and white spikeless golf shoes in Sand / white. Head cropped out; shoes visible.",
    "tier": "Golf"
  },
  {
    "id": "academy-shirt",
    "productId": "briggs-1-4-zip",
    "color": "Academy",
    "title": "Easy polish at the office",
    "image": "assets/wl-briggs-1-4-zip-academy-shirt-v1.jpg",
    "pieces": {
      "underlayer": "gunnar-sportshirt--thistle",
      "outerlayer": null,
      "pants": "ridge-sateen-pant--khaki",
      "shoes": "academy-shirt-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "The Thistle Gunnar Cotton Sport Shirt adds a crisp collar beneath the dark Academy blue terry. Khaki Ridge Sateen Pant and dark brown leather penny loafers give this casual office look a polished finish.",
    "alt": "Academy Briggs Quarter Zip styled with Gunnar Cotton Sport Shirt in Thistle, Ridge Sateen Pant in Khaki, Dark brown leather penny loafers in Dark brown. Head cropped out; shoes visible.",
    "tier": "Polished"
  },
  {
    "id": "academy-jacket",
    "productId": "briggs-1-4-zip",
    "color": "Academy",
    "title": "An easy evening finish",
    "image": "assets/wl-briggs-1-4-zip-academy-jacket-v1.jpg",
    "pieces": {
      "underlayer": "atlantic-long-sleeve-pocket-tee--pearl-heather",
      "outerlayer": "cedar-waxed-suede-vest--taupe",
      "pants": "ridge-sateen-pant--shadow",
      "shoes": "academy-jacket-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "Taupe Cedar Waxed Suede Vest adds tactile depth over the dark Academy blue terry. Pearl Heather Atlantic Long Sleeve Pocket Tee, Shadow Ridge Sateen Pant, and chocolate suede loafers make the palette dinner-ready.",
    "alt": "Academy Briggs Quarter Zip styled with Atlantic Long Sleeve Pocket Tee in Pearl Heather, Cedar Waxed Suede Vest in TAUPE, Ridge Sateen Pant in Shadow, Chocolate suede loafers in Chocolate. Head cropped out; shoes visible.",
    "tier": "Refined"
  },
  {
    "id": "black-casual",
    "productId": "briggs-1-4-zip",
    "color": "Black",
    "title": "A relaxed weekend uniform",
    "image": "assets/wl-briggs-1-4-zip-black-casual-v1.jpg",
    "pieces": {
      "underlayer": "atlantic-long-sleeve-pocket-tee--soft-sky",
      "outerlayer": null,
      "pants": "black-casual-jeans",
      "shoes": "black-casual-shoes"
    },
    "accessories": [],
    "denimApproved": true,
    "description": "A Soft Sky tee keeps the matte black terry relaxed; your washed gray jeans and off-white leather low-top sneakers make it easy for a weekend afternoon.",
    "alt": "Black Briggs Quarter Zip styled with Atlantic Long Sleeve Pocket Tee in Soft Sky, Your washed gray jeans in Washed gray, Off-white leather low-top sneakers in Off-white. Head cropped out; shoes visible.",
    "tier": "Casual"
  },
  {
    "id": "black-shirt",
    "productId": "briggs-1-4-zip",
    "color": "Black",
    "title": "A polished casual office layer",
    "image": "assets/wl-briggs-1-4-zip-black-shirt-v1.jpg",
    "pieces": {
      "underlayer": "nells-button-front--anchor-blue-steel",
      "outerlayer": null,
      "pants": "ridge-sateen-pant--blue-steel",
      "shoes": "black-shirt-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "The ANCHOR / BLUE STEEL Nells Jacquard Button Front adds a crisp collar beneath the matte black terry. Blue Steel Ridge Sateen Pant and tobacco suede loafers give this casual office look a polished finish.",
    "alt": "Black Briggs Quarter Zip styled with Nells Jacquard Button Front in ANCHOR / BLUE STEEL, Ridge Sateen Pant in Blue Steel, Tobacco suede loafers in Tobacco. Head cropped out; shoes visible.",
    "tier": "Polished"
  },
  {
    "id": "black-jacket",
    "productId": "briggs-1-4-zip",
    "color": "Black",
    "title": "A considered dinner layer",
    "image": "assets/wl-briggs-1-4-zip-black-jacket-v1.jpg",
    "pieces": {
      "underlayer": "beau-polo--black",
      "outerlayer": "wise-full-zip-vest--shadow-heather",
      "pants": "mbp0019-arthur-corduroy-5-pocket--khaki",
      "shoes": "black-jacket-shoes"
    },
    "accessories": [],
    "denimApproved": false,
    "description": "Shadow Heather Wise Full Zip Vest adds tactile depth over the matte black terry. Black Beau Polo, Khaki Arthur Corduroy Pant, and dark brown leather chelsea boots make the palette dinner-ready.",
    "alt": "Black Briggs Quarter Zip styled with Beau Polo in Black, Wise Full Zip Vest in SHADOW HEATHER, Arthur Corduroy Pant in Khaki, Dark brown leather Chelsea boots in Dark brown. Head cropped out; shoes visible.",
    "tier": "Refined"
  }
];
function isAnchorEnabled(catalog,id){const p=catalog.products[id];return !!(p?.active&&p.enabled&&p.isLayer&&!p.licensed)}
function isEligiblePiece(item){return !!item&&(item.ownership==='closet'||(item.active&&!item.licensed))}
function validLooks(catalog,looks,productId,color){return looks.filter(l=>l.productId===productId&&l.color===color&&l.image&&Object.values(l.pieces).filter(Boolean).every(id=>isEligiblePiece(catalog.items[id]))&&l.accessories.every(id=>isEligiblePiece(catalog.items[id]))&&(!(catalog.items[l.pieces.pants]?.isDenim||l.pieces.pants==='denim')||l.denimApproved));}
function createState(catalog,looks,{productId,color,lookId,remembered={}}){
 if(!isAnchorEnabled(catalog,productId))throw Error('This layer is not enabled');
 const anchorItemId=catalog.products[productId].anchorItems[color];
 if(!anchorItemId||!isEligiblePiece(catalog.items[anchorItemId]))throw Error('Unsupported color');
 const options=validLooks(catalog,looks,productId,color);if(!options.length)throw Error('No approved look for this color');
 const chosen=options.find(l=>l.id===(lookId||remembered[`${productId}:${color}`]))||options[0];
 return {productId,color,anchorItemId,lookId:chosen.id,pieces:{...chosen.pieces},validLookIds:options.map(l=>l.id),remembered:{...remembered,[`${productId}:${color}`]:chosen.id}};
}
function changeAnchor(state,catalog,looks,next){return createState(catalog,looks,{...next,remembered:state.remembered})}
function getChoices(state,looks,role){return [...new Set(looks.filter(l=>state.validLookIds.includes(l.id)).map(l=>l.pieces[role]))]}
function choosePiece(state,looks,role,pieceId){const candidates=looks.filter(l=>state.validLookIds.includes(l.id)&&l.pieces[role]===pieceId);if(!candidates.length)throw Error('This pairing is not available');const chosen=candidates.find(l=>l.id===state.lookId)||candidates.sort((a,b)=>Object.keys(state.pieces).filter(k=>a.pieces[k]!==state.pieces[k]).length-Object.keys(state.pieces).filter(k=>b.pieces[k]!==state.pieces[k]).length)[0];return {state:{...state,lookId:chosen.id,pieces:{...chosen.pieces},remembered:{...state.remembered,[`${state.productId}:${state.color}`]:chosen.id}},changedRoles:Object.keys(state.pieces).filter(k=>k!==role&&state.pieces[k]!==chosen.pieces[k])}}
function getCoverage(catalog,looks){return Object.values(catalog.products).filter(p=>isAnchorEnabled(catalog,p.id)).flatMap(p=>p.colors.filter(c=>!validLooks(catalog,looks,p.id,c).length).map(color=>({productId:p.id,color})))}

class ImageCoordinator{
 constructor(loader){this.loader=loader;this.revision=0;this.disposed=false}
 async show(id,success,failure=()=>{}){const revision=++this.revision;try{const result=await this.loader(id);if(!this.disposed&&revision===this.revision)success(result)}catch(error){if(!this.disposed&&revision===this.revision)failure(error)}}
 destroy(){this.disposed=true;this.revision++}
}
function loadImage(src){return new Promise((resolve,reject)=>{const img=new Image();img.onload=()=>resolve(img);img.onerror=()=>reject(Error('This styled image could not load.'));img.src=src})}

function createReview(state,catalog,requestId,onlyItem){const ids=[...new Set([state.anchorItemId,...Object.values(state.pieces).filter(Boolean)])];return {requestId,color:state.color,lookId:state.lookId,closetItemIds:ids.filter(id=>catalog.items[id]?.ownership==='closet'),rows:ids.filter(id=>(!onlyItem||id===onlyItem)&&catalog.items[id]?.ownership==='turtleson').map(itemId=>({itemId,included:true,quantity:1,options:{},priceCents:catalog.items[itemId].priceCents,currency:catalog.items[itemId].currency}))}}
function validateReview(review,catalog){const errors=[],lines=[];for(const row of review.rows.filter(r=>r.included)){const item=catalog.items[row.itemId];if(!isEligiblePiece(item)||item.ownership!=='turtleson'||!item.verified){errors.push('This item is not available to buy.');continue}if(!Number.isInteger(row.quantity)||row.quantity<1||row.quantity>10){errors.push('Choose a quantity from 1 to 10.');continue}const variant=item.variants.find(v=>Object.entries(v.options).every(([k,v])=>row.options[k]===v)&&Object.keys(row.options).every(k=>k in v.options));if(!variant){errors.push(`Choose all sizes for ${item.title||item.id}.`);continue}if(!variant.available){errors.push(`${item.title||item.id} is unavailable in that size.`);continue}if(variant.priceCents!==row.priceCents||item.currency!==row.currency){errors.push('Price changed. Please reopen the review.');continue}lines.push({itemId:item.id,variantId:variant.id,quantity:row.quantity,options:{...variant.options},priceCents:variant.priceCents,currency:item.currency,title:item.title,color:item.color,image:item.image,url:item.url})}if(!review.rows.some(r=>r.included))errors.push('Select at least one item.');if(new Set(lines.map(l=>l.currency)).size>1)errors.push('Currencies must match.');return {ok:!errors.length,errors,lines,subtotalCents:lines.reduce((n,l)=>n+l.quantity*l.priceCents,0),currency:lines[0]?.currency||'USD'}}

const money=cents=>new Intl.NumberFormat('en-US',{style:'currency',currency:activeCurrency,maximumFractionDigits:2}).format(cents/100);
const esc=value=>String(value??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
function icon(id){const paths={sneakers:'<path d="M12 49l14-23 14 6 8 13 30 8q14 3 12 13H10z"/><path d="M10 65h80M31 36l15 4M28 42l18 4"/>',loafers:'<path d="M10 55l12-21q15-6 26 6l12 12 22 2q11 3 8 13H10z"/><path d="M27 36l5 19 18-3M10 66h80"/>',boots:'<path d="M25 15h28l-2 31 17 7 17 3q9 2 7 12H20l-2-16z"/><path d="M20 66h72M34 18l-4 28 14 3 6-31"/>',denim:'<path d="M25 13h50l-2 25-9 42H49l1-37-10 37H25l1-42z"/><path d="M26 24h47M48 14l2 24M30 26l-2 10M65 26l4 10"/>',watch:'<path d="M43 9h16v21H43zM43 64h16v24H43z"/><circle cx="51" cy="48" r="21"/><path d="M51 35v13l10 6"/>',sunglasses:'<path d="M10 36q18-7 33 0v17q-3 14-20 10-13-2-13-27zM57 36q18-7 33 0v17q-3 14-20 10-13-2-13-27zM43 39q7-5 14 0M10 38l-6-12M90 38l6-12"/>'};return `<svg viewBox="0 0 100 100" aria-hidden="true" class="closet-icon"><g fill="${id==='denim'?'#334762':id==='sneakers'?'#fcfaf5':'#c5aa84'}" stroke="#74614b" stroke-width="2" stroke-linejoin="round">${paths[id]||paths.watch}</g></svg>`}
function itemImage(item,cls=''){return item.image?`<img class="${cls}" src="${esc(item.image)}" alt="${esc(item.title+' · '+item.color)}" loading="lazy">`:icon(item.icon||item.id)}
function swatches(state,catalog,looks){const colors=catalog.products[state.productId].colors.filter(color=>{try{createState(catalog,looks,{productId:state.productId,color});return true}catch{return false}});return `<div class="anchor-colors"><span class="color-picker-label">Explore this layer in</span><div class="swatches" role="group" aria-label="Starting layer color">${colors.map(color=>`<button type="button" class="wl-color-swatch" data-color="${esc(color)}" aria-label="${esc(color)}" title="${esc(color)}" aria-pressed="${state.color===color}"><span class="wl-color-dot" aria-hidden="true"></span></button>`).join('')}</div></div>`}
const roleNames={underlayer:'Underlayer',outerlayer:'Outer layer',pants:'Bottoms',shoes:'Shoes'};
class Studio{
 constructor(root,{catalog,looks,state,onChange,onReview,onQuickView,onColor}){Object.assign(this,{root,catalog,looks,state,onChange,onReview,onQuickView,onColor});this.images=new ImageCoordinator(loadImage);this.clickHandler=event=>this.click(event);root.addEventListener('click',this.clickHandler);this.render()}
 setState(state){this.state=state;this.render()}
 chooseLook(id){const viewport={left:window.scrollX,top:window.scrollY,behavior:'instant'};this.state=createState(this.catalog,this.looks,{...this.state,lookId:id});this.onChange(this.state);this.render();this.root.getBoundingClientRect();window.scrollTo(viewport);requestAnimationFrame(()=>{if(this.root.isConnected){window.scrollTo(viewport);}})}
 click(event){const button=event.target.closest('button');if(!button)return;const {color,look,buy,retry,quickview}=button.dataset;if(quickview){this.onQuickView?.(quickview,button);return;}if(color){if(this.onColor){this.onColor(color);return;}this.state=changeAnchor(this.state,this.catalog,this.looks,{productId:this.state.productId,color});this.onChange(this.state);this.render()}else if(look)this.chooseLook(look);else if(buy)this.onReview(buy==='look'?undefined:buy);else if(retry)this.render();}
 render(){if(this.state.stylingEnabled===false){this.root.replaceChildren();return}const active=document.activeElement;const focus=active&&this.root.contains(active)?{label:active.getAttribute('aria-label'),look:active.dataset.look}:null;const state=this.state,anchor=this.catalog.items[state.anchorItemId],look=this.looks.find(l=>l.id===state.lookId),options=this.looks.filter(l=>state.validLookIds.includes(l.id)),index=options.findIndex(l=>l.id===look.id);this.root.innerHTML=`
 <div class="studio-heading"><div><p class="eyebrow">Plays well with others</p><h2>Wardrobe Logic</h2><p class="subhead">Your Briggs Quarter Zip. Ready for life’s moments.</p></div><div class="anchor-lock">${itemImage(anchor)}<div><span class="eyebrow">Your starting layer · locked</span><strong>Briggs Quarter Zip</strong><small>${esc(state.color)}</small>${swatches(state,this.catalog,this.looks)}</div></div></div>
 <div class="studio-body"><div class="visual-column"><div class="outfit-stage"><div class="main-scene" tabindex="0" aria-label="Styled look. Use left and right arrow keys to change look." aria-busy="true"><div class="scene-status">Preparing your look…</div><img class="outfit-photo" alt="${esc(look.alt)}" hidden><span class="scene-tag">${esc(state.color.replace(' Heather',''))} / ${String(index+1).padStart(2,'0')}</span></div><div class="alternate-rail">${options.filter(l=>l.id!==look.id).slice(0,2).map(l=>`<button data-look="${l.id}" class="alternate"><img src="${l.image}" alt="${esc(l.alt)}"><span>${esc(l.title)}</span><small>${esc(l.tier)} · View this look</small></button>`).join('')}</div></div><div class="look-caption"><button class="round" data-look="${options[(index+options.length-1)%options.length].id}" aria-label="Previous look">‹</button><div><span class="eyebrow">${String(index+1).padStart(2,'0')} / ${String(options.length).padStart(2,'0')} ways to wear it</span><h3>${esc(look.title)}</h3></div><button class="round" data-look="${options[(index+1)%options.length].id}" aria-label="Next look">›</button></div><p class="look-description">${esc(look.description)}</p><div class="look-dots" aria-label="Choose a complete look">${options.map((l,i)=>`<button data-look="${l.id}" aria-label="Look ${i+1}: ${esc(l.title)}" aria-pressed="${l.id===look.id}" class="${l.id===look.id?'active':''}"></button>`).join('')}</div></div>
 <div class="builder"><div class="builder-heading"><p class="eyebrow">Make the look yours</p><h3>In this look</h3><p>The pieces in your selected look.</p><div class="swatches layer-color-summary"><span>${esc(state.color)} · follows your selected Briggs Quarter Zip</span></div></div>${Object.keys(roleNames).map(role=>this.row(role)).join('')}<button class="primary look-buy" data-buy="look">Add this look to cart <span>→</span></button><p class="buy-note">Choose your sizes first. Keep the pieces you need.</p></div></div><p class="studio-footnote">Styled imagery is illustrative. Jeans and shoes are styling suggestions from your own closet.</p><div class="sr-only studio-live" aria-live="polite"></div>`;
 const scene=this.root.querySelector('.main-scene'),photo=scene.querySelector('img'),status=scene.querySelector('.scene-status');this.images.show(look.image,img=>{photo.src=img.src;photo.hidden=false;status.hidden=true;scene.setAttribute('aria-busy','false')},()=>{status.innerHTML=`<img class="anchor-fallback" src="${esc(anchor.image)}" alt="${esc(anchor.title+' · '+anchor.color)}"><span>Your styled image is unavailable.</span><button class="text-button" data-retry="true">Try again</button>`;scene.setAttribute('aria-busy','false')});
 scene.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.chooseLook(options[(index+(e.key==='ArrowRight'?1:options.length-1))%options.length].id);this.root.querySelector('.main-scene').focus({preventScroll:true})}});
 if(focus){const buttons=Array.from(this.root.querySelectorAll('button'));const target=buttons.find(b=>focus.label&&b.getAttribute('aria-label')===focus.label)||scene;target.focus({preventScroll:true})}
 let touchStart;scene.addEventListener('touchstart',e=>touchStart=e.changedTouches[0].clientX,{passive:true});scene.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-touchStart;if(Math.abs(dx)>60)this.chooseLook(options[(index+(dx<0?1:options.length-1))%options.length].id)},{passive:true});
 }
 row(role){const id=this.state.pieces[role],item=this.catalog.items[id];if(!item)return '';return `<div class="piece-row" data-piece-id="${esc(id)}"><div class="row-label"><span class="eyebrow">${roleNames[role]}</span><small>${item.ownership==='closet'?'From your closet':'Turtleson'}</small></div><div class="piece-content"><div class="piece-image">${itemImage(item)}</div><div class="piece-detail"><strong>${esc(item.title)}</strong><small>${esc(item.color||item.note||'')}</small>${item.ownership==='turtleson'?`<div class="piece-links">${this.onQuickView?`<button class="text-button view-piece" data-quickview="${esc(id)}" aria-label="Quick view ${esc(item.title)}">View piece</button>`:`<a href="${item.url}" target="_blank" rel="noopener">View piece ↗</a>`}<span>${money(item.priceCents)}</span></div>`:''}</div>${item.ownership==='turtleson'?`<button class="round add-piece" data-buy="${esc(id)}" aria-label="Add ${esc(item.title)}">＋</button>`:''}</div></div>`}
 destroy(){this.root.removeEventListener('click',this.clickHandler);this.images.destroy();this.root.replaceChildren()}
}

function hydrateItem(item, product, currency) {
  if (!product || /licensed|collegiate|ncaa|fanshop/i.test((product.tags || []).join(' '))) return {...item, active:false, verified:false, variants:[]};
  const names = product.options.map(o => typeof o === 'string' ? o : o.name);
  const colorIndex = names.findIndex(n => /^(color|colour)$/i.test(n));
  const variants = product.variants.filter(v => colorIndex < 0 || String(v.options[colorIndex]).toLowerCase() === item.color.toLowerCase()).map(v => ({id:String(v.id), options:Object.fromEntries(names.map((n,i)=>[n,v.options[i]]).filter(([n])=>!/^(color|colour)$/i.test(n))), available:v.available, priceCents:v.price, sku:v.sku}));
  const live = product.variants.find(v => variants.some(x=>x.id===String(v.id)) && v.available) || product.variants.find(v=>variants.some(x=>x.id===String(v.id)));
  return {...item,title:product.title,currency,active:variants.length>0,verified:true,variants,priceCents:live?.price || item.priceCents,image:live?.featured_image?.src || item.sourceImage,url:`${globalThis.Shopify?.routes?.root || '/'}products/${item.handle}?variant=${live?.id || ''}`};
}
function attemptStatus(cart, attempt, lines) {
  const found = (cart.items || []).filter(i=>i.properties?._wardrobe_logic_attempt===attempt);
  if (!found.length) return 'absent';
  return lines.every(l=>found.filter(i=>String(i.variant_id)===String(l.variantId)).reduce((n,i)=>n+i.quantity,0)>=l.quantity) ? 'complete':'partial';
}
async function addReviewedLook({request, root, attempt, lines, persist}) {
  const before = await request(root+'cart.js');
  const prior = attemptStatus(before,attempt,lines);
  if (prior!=='absent') return {status:prior,cart:before};
  persist({attempt,lines});
  let response, failure;
  try { response = await request(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:lines.map(l=>({id:l.variantId,quantity:l.quantity,properties:{_wardrobe_logic_attempt:attempt}}))})}); } catch(e) { failure=e; }
  try {
    const cart = await request(root+'cart.js');
    const status = attemptStatus(cart,attempt,lines);
    if (status!=='absent') return {status,cart};
    if (response) return {status:'uncertain',cart};
    if (failure?.definite) return {status:'rejected',cart,message:failure.message};
    return {status:'uncertain',cart};
  } catch { return {status:'uncertain'}; }
}

function quickViewImages(item,product){
 const source=image=>{const url=typeof image==='string'?image:image?.src;return url?.startsWith('//')?'https:'+url:url;};
 const names=product.options.map(o=>typeof o==='string'?o:o.name),ci=names.findIndex(n=>/^(color|colour)$/i.test(n));
 const colorVariants=product.variants.filter(v=>ci<0||String(v.options[ci]).toLowerCase()===item.color.toLowerCase());
 const singleColor=ci<0||new Set(product.variants.map(v=>v.options[ci])).size===1;
 const images=product.images.map(source).filter(Boolean),selected=new Set(colorVariants.map(v=>source(v.featured_image)).filter(Boolean));
 const other=new Set(product.variants.filter(v=>ci>=0&&String(v.options[ci]).toLowerCase()!==item.color.toLowerCase()).map(v=>source(v.featured_image)).filter(Boolean));
 let within=false;
 const gallery=singleColor?images:images.filter(src=>{if(other.has(src)){within=false;return false;}if(selected.has(src))within=true;return within;});
 return [...new Set([source(item.image),...selected,...gallery].filter(Boolean))];
}
function quickViewVariant(item,options){return item.variants.find(v=>v.available&&Object.entries(v.options).every(([name,value])=>options[name]===value));}
function quickDescription(html){
 const doc=new DOMParser().parseFromString(html||'','text/html');
 doc.querySelectorAll('script,style,iframe,object').forEach(el=>el.remove());
 const blocks=[...doc.body.querySelectorAll('p,li,h2,h3,h4')].filter(el=>!el.querySelector('p,li')).map(el=>({tag:el.closest('li')?'li':'p',text:el.textContent.trim()})).filter(el=>el.text);
 if(!blocks.length)return `<p>${esc(doc.body.textContent.trim())}</p>`;
 return blocks.map(b=>`<${b.tag}>${esc(b.text)}</${b.tag}>`).join('').replace(/(?:<li>[\s\S]*?<\/li>)+/g,list=>`<ul>${list}</ul>`);
}
class PieceQuickView{
 constructor({host,catalog,getProduct,onReview}){
  Object.assign(this,{host,catalog,getProduct,onReview});this.version=0;this.lifetime=new AbortController();
  this.dialog=document.createElement('dialog');this.dialog.className='wl-quick-view';this.dialog.setAttribute('aria-labelledby','wl-quick-title');host.append(this.dialog);
  this.dialog.addEventListener('close',()=>{this.version++;if(this.trigger?.isConnected)this.trigger.focus({preventScroll:true});},{signal:this.lifetime.signal});
  this.dialog.addEventListener('click',e=>{const action=e.target.closest('button');if(action?.hasAttribute('data-quick-close'))this.close();if(action?.hasAttribute('data-quick-review')){const options={...this.options},id=this.item.id;this.close();this.onReview(id,options);}if(action?.hasAttribute('data-quick-retry'))this.open(this.item.id,this.trigger);if(action?.hasAttribute('data-quick-image'))this.selectPhoto(Number(action.dataset.quickImage));if(action?.hasAttribute('data-quick-step'))this.selectPhoto(this.photoIndex+Number(action.dataset.quickStep));if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.close();}},{signal:this.lifetime.signal});
  this.dialog.addEventListener('change',e=>{if(!e.target.matches('[data-quick-option]'))return;this.options[e.target.dataset.quickOption]=e.target.value;this.update();},{signal:this.lifetime.signal});
 }
 close(){this.version++;if(this.dialog.open)this.dialog.close();}
 async open(id,trigger){
  const version=++this.version;this.trigger=trigger;this.item=this.catalog.items[id];this.options={};
  this.dialog.innerHTML=`<div class="quick-top"><span class="eyebrow">A piece in your look</span><button class="round" data-quick-close aria-label="Close quick view" autofocus>×</button></div><h2 id="wl-quick-title">${esc(this.item.title)}</h2><p role="status">Loading the details…</p>`;
  if(!this.dialog.open)this.dialog.showModal();
  try{const product=await this.getProduct(this.item);if(version!==this.version||!this.dialog.open)return;this.item=this.catalog.items[id];if(!this.item.active||!this.item.verified)throw new Error('Unavailable');this.product=product;this.render();}catch{if(version!==this.version||!this.dialog.open)return;this.dialog.innerHTML=`<div class="quick-top"><span class="eyebrow">A piece in your look</span><button class="round" data-quick-close aria-label="Close quick view" autofocus>×</button></div><h2 id="wl-quick-title">${esc(this.item.title)}</h2><p>We couldn’t load the current details. You can try again or return to your look.</p><button class="primary" data-quick-retry>Try again</button><a class="text-button" href="${esc(this.item.url)}" target="_blank" rel="noopener">View full product details ↗</a>`;}
 }
 render(){
  const item=this.item,images=quickViewImages(item,this.product),names=[...new Set(item.variants.flatMap(v=>Object.keys(v.options)))];
  this.dialog.innerHTML=`<div class="quick-top"><span class="eyebrow">Turtleson · A piece in your look</span><button class="round" data-quick-close aria-label="Close quick view">×</button></div><div class="quick-grid"><div class="quick-media"><div class="quick-gallery" tabindex="0" role="region" aria-label="${esc(item.title)} product photos">${images.map((src,i)=>`<img class="quick-photo" src="${esc(src)}" alt="${esc(item.title+' · '+item.color+' · Photo '+(i+1)+' of '+images.length)}" loading="${i===0?'eager':'lazy'}">`).join('')}</div>${images.length>1?`<div class="quick-gallery-controls"><button class="round" data-quick-step="-1" aria-label="Previous product photo" disabled>‹</button><span class="quick-photo-count" aria-live="polite">1 / ${images.length}</span><button class="round" data-quick-step="1" aria-label="Next product photo">›</button></div><div class="quick-thumbs" aria-label="Product photos">${images.map((src,i)=>`<button data-quick-image="${i}" aria-label="Product photo ${i+1}" aria-pressed="${i===0}"><img src="${esc(src)}" alt="" loading="lazy"></button>`).join('')}</div>`:''}</div><div class="quick-copy"><h2 id="wl-quick-title">${esc(item.title)}</h2><p class="quick-color">${esc(item.color)}</p><p class="quick-price">${money(item.priceCents)}</p><p class="quick-context">Selected to complement your Briggs Quarter Zip.</p><div class="quick-options">${names.map(name=>`<label>${esc(name)}<select data-quick-option="${esc(name)}" aria-label="${esc(name)} for ${esc(item.title)}"><option value="">Select ${esc(name.toLowerCase())}</option>${[...new Set(item.variants.map(v=>v.options[name]))].map(value=>`<option value="${esc(value)}">${esc(value)}</option>`).join('')}</select></label>`).join('')}</div><p class="quick-selection" role="status"></p><button class="primary" data-quick-review disabled>Review &amp; add this piece <span>→</span></button><button class="text-button quick-return" data-quick-close>Return to your look</button><details class="quick-description"><summary>About this piece</summary>${quickDescription(this.product.description)}</details><a class="quick-full" href="${esc(item.url)}" target="_blank" rel="noopener">View full product details ↗</a></div></div>`;
  this.photos=images;this.photoIndex=0;
  const gallery=this.dialog.querySelector('.quick-gallery');
  gallery.addEventListener('scroll',()=>{this.photoIndex=Math.max(0,Math.min(this.photos.length-1,Math.round(gallery.scrollLeft/gallery.clientWidth)));this.updateGallery();},{passive:true,signal:this.lifetime.signal});
  gallery.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.selectPhoto(this.photoIndex+(e.key==='ArrowRight'?1:-1));}},{signal:this.lifetime.signal});
  this.update();this.dialog.querySelector('[data-quick-close]').focus({preventScroll:true});
 }
 selectPhoto(index){
  const gallery=this.dialog.querySelector('.quick-gallery');
  this.photoIndex=Math.max(0,Math.min(this.photos.length-1,index));
  gallery.scrollTo({left:this.photoIndex*gallery.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  this.updateGallery();
 }
 updateGallery(){
  this.dialog.querySelectorAll('[data-quick-image]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.quickImage)===this.photoIndex)));
  const count=this.dialog.querySelector('.quick-photo-count');if(count)count.textContent=`${this.photoIndex+1} / ${this.photos.length}`;
  const previous=this.dialog.querySelector('[data-quick-step="-1"]'),next=this.dialog.querySelector('[data-quick-step="1"]');
  if(previous)previous.disabled=this.photoIndex===0;if(next)next.disabled=this.photoIndex===this.photos.length-1;
 }
 update(){
  const item=this.item,variant=quickViewVariant(item,this.options);
  this.dialog.querySelectorAll('[data-quick-option]').forEach(select=>{const name=select.dataset.quickOption;[...select.options].filter(o=>o.value).forEach(option=>{const available=item.variants.some(v=>v.available&&v.options[name]===option.value&&Object.entries(this.options).filter(([n,value])=>n!==name&&value).every(([n,value])=>v.options[n]===value));option.disabled=!available;option.textContent=option.value+(available?'':' — unavailable');});});
  this.dialog.querySelector('[data-quick-review]').disabled=!variant;
  this.dialog.querySelector('.quick-price').textContent=money(variant?.priceCents??item.priceCents);
  this.dialog.querySelector('.quick-selection').textContent=!item.variants.some(v=>v.available)?'This color is currently sold out.':variant?'Your size is available. Review it before adding.':'Choose your size to review this piece.';
 }
 destroy(){this.close();this.lifetime.abort();this.dialog.remove();}
}

const initialized = new WeakSet();
const controllers = new Map();
async function request(url, options) {
 const response = await fetch(url,{credentials:'same-origin',cache:'no-store',...options});
 const data = await response.json();
 if(!response.ok){const error=new Error(data.description || 'This selection could not be added.');error.definite=response.status>=400&&response.status<500;throw error;}
 return data;
}
async function initialize(host){
 if(initialized.has(host))return;initialized.add(host);
 const config=JSON.parse(host.querySelector('[data-wl-config]').textContent),rootPath=config.root,landing=config.landing;
 activeCurrency=config.currency;
 const localCatalog=structuredClone(catalog),localLooks=structuredClone(looks);
 const ui=host.querySelector('[data-wl-studio]'),reviewDialog=host.querySelector('dialog');
 for(const item of Object.values(localCatalog.items))if(item.ownership==='turtleson')item.image=item.sourceImage;
 for(const look of localLooks)look.image=config.images[look.id];
 let state,studio,review=null,returnFocus,pending=false,opening=false,revision=0,unresolved=null,queuedState=null;
 try{unresolved=JSON.parse(sessionStorage.getItem('turtleson-wl-pending')||'null');}catch{}
 const lifetime=new AbortController();let observer;controllers.set(host,()=>{revision++;lifetime.abort();observer?.disconnect();studio?.destroy();quickView?.destroy();initialized.delete(host);});
 let arrivalTimer,arrivalCleanup;
 function arriveAtStyling(){
  const destination=host.querySelector('#wardrobe');if(!destination)return;
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const header=document.querySelector('[data-section-type="header"]')||document.querySelector('header');
  const headerHeight=header?Math.max(0,header.getBoundingClientRect().bottom):100;
  const top=Math.max(0,window.scrollY+destination.getBoundingClientRect().top-headerHeight-20);
  const url=new URL(location.href);url.hash='wardrobe';history.replaceState(null,'',url);
  clearTimeout(arrivalTimer);arrivalCleanup?.();destination.classList.remove('wl-arriving');
  let finished=false;
  const finish=()=>{if(finished)return;finished=true;clearTimeout(arrivalTimer);arrivalCleanup?.();destination.focus({preventScroll:true});if(!reduced)destination.classList.add('wl-arriving');};
  arrivalCleanup=()=>window.removeEventListener('scrollend',finish);
  if(!reduced)window.addEventListener('scrollend',finish,{once:true,signal:lifetime.signal});
  window.scrollTo({top,behavior:reduced?'instant':'smooth'});
  if(reduced||Math.abs(window.scrollY-top)<2)finish();else arrivalTimer=setTimeout(finish,1600);
 }
 document.addEventListener('click',event=>{
  const link=event.target.closest('a');if(!link||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
  if(!link.closest('[data-wl-jump]')&&!(host.contains(link)&&link.getAttribute('href')?.endsWith('#wardrobe')))return;
  event.preventDefault();event.stopPropagation();arriveAtStyling();
 },{capture:true,signal:lifetime.signal});
 lifetime.signal.addEventListener('abort',()=>{clearTimeout(arrivalTimer);arrivalCleanup?.();});
 const detailGroup=document.querySelector('.wl-product-details');
 if(detailGroup){
  const details=[...detailGroup.querySelectorAll('.accordion')].map(accordion=>({button:accordion.querySelector('button'),panel:accordion.querySelector('.accordion__content'),inner:accordion.querySelector('.accordion__inner')})).filter(detail=>detail.button&&detail.panel&&detail.inner);
  function setDetail(detail,open){
   detail.button.setAttribute('aria-controls',detail.panel.id);
   detail.button.setAttribute('aria-expanded',String(open));
   detail.inner.dataset.open=String(open);
   detail.panel.setAttribute('aria-hidden',String(!open));
   detail.panel.style.display=open?'block':'none';
   detail.panel.style.removeProperty('height');
   detail.panel.style.removeProperty('overflow');
  }
  details.forEach(detail=>setDetail(detail,false));
  detailGroup.addEventListener('click',event=>{
   const selected=details.find(detail=>detail.button.contains(event.target));if(!selected)return;
   event.preventDefault();event.stopImmediatePropagation();
   const open=selected.button.getAttribute('aria-expanded')!=='true';
   details.forEach(detail=>setDetail(detail,detail===selected&&open));
  },{capture:true,signal:lifetime.signal});
 }
 async function refresh(ids){
  const handles=[...new Set(ids.map(id=>localCatalog.items[id].handle))];
  const products=new Map(await Promise.all(handles.map(async handle=>{try{return [handle,await request(rootPath+'products/'+handle+'.js')]}catch{return [handle,null]}})));
  for(const id of ids){const item=localCatalog.items[id];localCatalog.items[id]=hydrateItem(item,products.get(item.handle),config.currency);}
 }
 const quickView=new PieceQuickView({host,catalog:localCatalog,getProduct:async item=>{const product=await request(rootPath+'products/'+item.handle+'.js');localCatalog.items[item.id]=hydrateItem(item,product,config.currency);return product;},onReview:openReview});
 function selectedColor(){return document.querySelector('[data-section-type="product"][data-product-handle="briggs-1-4-zip"] .product__color-swatch.selected')?.getAttribute('data-option-value') || config.color;}
 function selectedAnchorOptions(){const selected=document.querySelector('[data-section-type="product"][data-product-handle="briggs-1-4-zip"] .dynamic-variant-button.selected[data-option-value]');const form=document.querySelector('[data-product-form][data-product-handle="briggs-1-4-zip"]');const variant=Object.values(localCatalog.items).filter(i=>i.handle==='briggs-1-4-zip').flatMap(i=>i.variants).find(v=>v.id===form?.querySelector('[name="id"]')?.value);const sizeButtons=document.querySelectorAll('[data-section-type="product"][data-product-handle="briggs-1-4-zip"] .product__chip.selected');return sizeButtons.length&&variant?variant.options:{};}
 function closeReview(){if(pending)return;if(reviewDialog.open)reviewDialog.close();review=null;}
 function updateState(next,push=true){revision++;closeReview();state=next;if(landing&&push){const url=new URL(location.href);url.searchParams.set('color',state.color);url.searchParams.set('look',state.lookId);history.pushState(null,'',url);}else if(!landing){const url=new URL(location.href);url.searchParams.set('look',state.lookId);url.searchParams.delete('color');history.replaceState(null,'',url);}syncLinks();}
 function chooseStudioColor(color){
  if(pending)return;
  const control=Array.from(document.querySelectorAll('[data-section-type="product"][data-product-handle="briggs-1-4-zip"] .product__color-swatch')).find(button=>button.dataset.optionValue===color);
  if(!control){notify('Please choose this color in the product options above.');return;}
  const viewport={left:window.scrollX,top:window.scrollY,behavior:'instant'};
  control.click();
  showState(selectedColor());
  window.scrollTo(viewport);
  requestAnimationFrame(()=>{if(ui.isConnected)window.scrollTo(viewport);});
 }
 function syncLinks(){ui.querySelectorAll('.wl-color-swatch').forEach(button=>{const original=Array.from(document.querySelectorAll('[data-section-type="product"][data-product-handle="briggs-1-4-zip"] .product__color-swatch')).find(control=>control.dataset.optionValue===button.dataset.color);const image=original?.querySelector('img');const dot=button.querySelector('.wl-color-dot');dot.style.backgroundColor=original?.style.backgroundColor||'';dot.style.backgroundImage=image?`url("${image.currentSrc||image.src}")`:'';});const preview=new URL(location.href).searchParams.get('preview_theme_id');host.querySelectorAll('a').forEach(a=>{const url=new URL(a.href,location.href);if(url.origin===location.origin&&preview)url.searchParams.set('preview_theme_id',preview);if(landing&&url.pathname.endsWith('/products/briggs-1-4-zip')){url.searchParams.set('variant',localCatalog.items[state.anchorItemId].variants.find(v=>v.available)?.id||'');url.searchParams.set('look',state.lookId);}a.href=url;});if(landing){const hero=host.querySelector('.intro-photo img');if(hero){hero.src=config.images[state.anchorItemId+'-jacket'];hero.alt=state.color+' Briggs Quarter Zip with a coordinated jacket, head cropped out';}}else{document.querySelectorAll('[data-wl-preview]').forEach(img=>{img.src=config.images[state.anchorItemId+'-'+img.dataset.wlPreview];});}}
 function showState(color,look){revision++;if(pending){queuedState={color,look};return;}closeReview();quickView.close();try{const next=createState(localCatalog,localLooks,{productId:"briggs-1-4-zip",color,lookId:look,remembered:state?.remembered||{}});state=next;host.hidden=false;host.querySelector('[data-wl-title]')?.remove();if(studio)studio.setState(state);else studio=new Studio(ui,{catalog:localCatalog,looks:localLooks,state,onChange:next=>{updateState(next);queueMicrotask(syncLinks);},onReview:openReview,onQuickView:(id,trigger)=>quickView.open(id,trigger),onColor:landing?undefined:chooseStudioColor});syncLinks();if(!landing){const url=new URL(location.href);url.searchParams.set('look',state.lookId);url.searchParams.delete('color');history.replaceState(null,'',url);}const jump=document.querySelector('[data-wl-jump]');if(jump)jump.hidden=false;}catch{host.hidden=false;studio?.destroy();studio=null;state=null;ui.innerHTML=`<div class="studio-heading"><div><p class="eyebrow">Wardrobe Logic / Briggs Quarter Zip</p><h2>More ways to wear it.</h2><p class="subhead">Choose your stock Briggs Quarter Zip color to explore three considered looks.</p><p>Choose a color below to explore its coordinated looks.</p>${swatches({productId:"briggs-1-4-zip",color},localCatalog,localLooks)}</div></div>`;ui.querySelectorAll('[data-color]').forEach(button=>button.addEventListener('click',()=>chooseStudioColor(button.dataset.color)));const jump=document.querySelector('[data-wl-jump]');if(jump)jump.hidden=true;}}
 async function openReview(onlyItem,selectedOptions){
  if(opening||pending)return;if(unresolved){showRecovery();return;}opening=true;returnFocus=document.activeElement;const version=revision;
  const ids=[...new Set([state.anchorItemId,...Object.values(state.pieces).filter(Boolean)])].filter(id=>localCatalog.items[id]?.ownership==='turtleson');
  notify('Checking sizes and availability…');await refresh(ids);opening=false;if(version!==revision)return;
  review=createReview(state,localCatalog,crypto.randomUUID(),onlyItem);
  const chosen=review.rows.find(row=>row.itemId===onlyItem);if(chosen&&selectedOptions)chosen.options={...selectedOptions};
  const anchor=review.rows.find(r=>r.itemId===state.anchorItemId);if(anchor&&!landing)anchor.options={...selectedAnchorOptions()};
  review.closetItemIds=[...new Set([...review.closetItemIds,...(localLooks.find(l=>l.id===review.lookId)?.accessories||[])])];
  renderReview();reviewDialog.showModal();
 }
 function notify(message){const toast=host.querySelector('.toast');toast.textContent=message;toast.hidden=false;clearTimeout(notify.timer);notify.timer=setTimeout(()=>toast.hidden=true,5000);}
 function renderReview(){reviewDialog.innerHTML=`<div class="dialog-heading"><div><p class="eyebrow">Make the look yours</p><h2 id="review-title">A few good choices.</h2><p>${esc(review.color)} · ${esc(localLooks.find(l=>l.id===review.lookId)?.title)}</p></div><button class="round close-review" aria-label="Close outfit review">×</button></div>${review.lookId?`<div class="review-look"><img src="${esc(localLooks.find(l=>l.id===review.lookId)?.image)}" alt="${esc(localLooks.find(l=>l.id===review.lookId)?.alt)}"><div><span class="eyebrow">Your look</span><h3>${esc(localLooks.find(l=>l.id===review.lookId)?.title)}</h3><p>Start with your Briggs Quarter Zip.<br>Add only what you need.</p></div></div>`:''}<p class="review-intro">Choose sizes for the pieces you want. Already own something? Simply leave it out.</p><div class="review-rows">${review.rows.map((row,i)=>{const item=localCatalog.items[row.itemId];const names=[...new Set(item.variants.flatMap(v=>Object.keys(v.options)))];return `<div class="review-row ${!row.included?'excluded':''}"><label class="include-label"><input type="checkbox" data-include="${i}" ${row.included?'checked':''}><span class="sr-only">Include ${esc(item.title)}</span></label><div class="review-image">${itemImage(item)}</div><div class="review-detail"><strong>${esc(item.title)}</strong><small>${esc(item.color)} · <span data-wl-row-price="${i}">${money(row.priceCents)}</span></small><div class="review-options">${names.map(name=>`<label>${name}<select data-row="${i}" data-option="${name}" aria-label="${esc(item.title+' '+name)}" ${!row.included?'disabled':''}><option value="">Choose ${name.toLowerCase()}</option>${[...new Set(item.variants.map(v=>v.options[name]))].map(value=>`<option value="${esc(value)}" ${!item.variants.some(v=>v.available&&v.options[name]===value)?'disabled':''} ${row.options[name]===value?'selected':''}>${esc(value)}${!item.variants.some(v=>v.available&&v.options[name]===value)?' — sold out':''}</option>`).join('')}</select></label>`).join('')}<label>Qty<select data-quantity="${i}" aria-label="${esc(item.title)} quantity" ${!row.included?'disabled':''}>${[1,2,3,4,5].map(n=>`<option ${row.quantity===n?'selected':''}>${n}</option>`).join('')}</select></label></div></div></div>`}).join('')}</div><div class="review-closet"><span>Already in your wardrobe</span><p>${review.closetItemIds.map(id=>esc(localCatalog.items[id].title)).join(' · ')||'No additional closet references in this selection.'}</p><p>Styling inspiration only. These won't be added to your bag.</p></div><div id="review-error" class="form-error" role="alert"></div><div class="review-bottom"><div><small>Selected pieces</small><strong id="review-subtotal"></strong><small>Shipping and taxes calculated at checkout.</small></div><button class="primary confirm-add">Add selected to cart <span>→</span></button></div><p class="preview-disclaimer">Only your selected Turtleson pieces are added. <a href="${rootPath}cart">View your cart ↗</a></p>`;reviewDialog.querySelector('.close-review').onclick=closeReview;reviewDialog.querySelectorAll('[data-include]').forEach(input=>input.onchange=()=>{review.rows[Number(input.dataset.include)].included=input.checked;renderReview();reviewDialog.querySelector(`[data-include="${input.dataset.include}"]`).focus()});reviewDialog.querySelectorAll('[data-option]').forEach(select=>select.onchange=()=>{review.rows[Number(select.dataset.row)].options[select.dataset.option]=select.value;updateSubtotal()});reviewDialog.querySelectorAll('[data-quantity]').forEach(select=>select.onchange=()=>{review.rows[Number(select.dataset.quantity)].quantity=Number(select.value);updateSubtotal()});reviewDialog.querySelector('.confirm-add').onclick=confirmAdd;updateSubtotal()}

 function updateSubtotal(){if(!review)return;for(const row of review.rows){const item=localCatalog.items[row.itemId];const variant=item.variants.find(v=>Object.entries(v.options).every(([k,v])=>row.options[k]===v));row.priceCents=variant?.priceCents||item.priceCents;}const total=review.rows.filter(r=>r.included).reduce((n,r)=>n+r.priceCents*r.quantity,0);review.rows.forEach((r,i)=>{const el=reviewDialog.querySelector('[data-wl-row-price="'+i+'"]');if(el)el.textContent=money(r.priceCents);});reviewDialog.querySelector('#review-subtotal').textContent=money(total);reviewDialog.querySelector('.confirm-add').disabled=pending||review.uncertain||!validateReview(review,localCatalog).ok;reviewDialog.querySelector('#review-error').textContent='';}
 async function confirmAdd(){
  if(pending||!review||review.uncertain||unresolved)return;const result=validateReview(review,localCatalog);const error=reviewDialog.querySelector('#review-error');if(!result.ok){error.textContent=[...new Set(result.errors)].join(' ');return;}
  pending=true;reviewDialog.querySelectorAll('button,select,input').forEach(el=>el.disabled=true);error.textContent='Confirming current prices and availability…';
  try{
   await refresh(review.rows.filter(r=>r.included).map(r=>r.itemId));
   const checked=validateReview(review,localCatalog);if(!checked.ok){pending=false;renderReview();errorAfterRender(checked.errors.join(' '));return;}
   const added=await addReviewedLook({request,root:rootPath,attempt:review.requestId,lines:checked.lines,persist:value=>{unresolved=value;try{sessionStorage.setItem('turtleson-wl-pending',JSON.stringify(value))}catch{}}});
   if(added.status==='complete'){unresolved=null;try{sessionStorage.removeItem('turtleson-wl-pending')}catch{};pending=false;closeReview();notify(`${checked.lines.reduce((n,l)=>n+l.quantity,0)} pieces added to your cart.`);refreshCart(added.cart);}
   else if(added.status==='rejected'){unresolved=null;pending=false;try{sessionStorage.removeItem('turtleson-wl-pending')}catch{}renderReview();errorAfterRender(added.message);}
   else{pending=false;review.uncertain=true;renderReview();errorAfterRender(added.status==='partial'?'Some pieces were added. Review your cart before adding the remaining pieces.':'We could not confirm the full addition. Check your cart before trying again.');refreshCart(added.cart,false);}
  }catch(e){pending=false;renderReview();errorAfterRender(e.message || 'Please check your connection and try again.');}finally{if(!pending&&queuedState){const next=queuedState;queuedState=null;showState(next.color,next.look);}}
 }
 function errorAfterRender(message){reviewDialog.querySelector('#review-error').textContent=message;}
 function showRecovery(){returnFocus=document.activeElement;reviewDialog.innerHTML=`<div class="dialog-heading"><h2 id="review-title">Check your cart.</h2><button class="round close-recovery" aria-label="Close cart review">×</button></div><p class="review-intro">Your earlier addition needs a quick review. Check which pieces are already in your cart before adding anything else.</p><a class="primary" href="${rootPath}cart">View my cart ↗</a><p class="review-intro"><label><input type="checkbox" class="checked-cart"> I’ve reviewed the pieces in my cart.</label></p><button class="primary resume-styling" disabled>Continue styling →</button><p class="form-error" role="alert"></p>`;reviewDialog.querySelector('.close-recovery').onclick=closeReview;const checkbox=reviewDialog.querySelector('.checked-cart'),button=reviewDialog.querySelector('.resume-styling');checkbox.onchange=()=>button.disabled=!checkbox.checked;button.onclick=async()=>{button.disabled=true;try{await request(rootPath+'cart.js');unresolved=null;sessionStorage.removeItem('turtleson-wl-pending');closeReview();}catch{reviewDialog.querySelector('.form-error').textContent='Your cart could not be reached. Please try again when your connection returns.';button.disabled=false;}};reviewDialog.showModal();}
 function refreshCart(cart,open=true){document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));if(cart)document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=cart.item_count);if(open)setTimeout(()=>{const trigger=document.querySelector('a[aria-label="Open cart modal"]');if(trigger)trigger.click();else location.assign(rootPath+'cart');},350);}
 reviewDialog.addEventListener('cancel',event=>{if(pending)event.preventDefault()});reviewDialog.addEventListener('close',()=>{if(pending)return;review=null;if(returnFocus?.isConnected)returnFocus.focus({preventScroll:true});else ui.querySelector('.look-buy')?.focus({preventScroll:true});});
 reviewDialog.addEventListener('click',e=>{if(e.target===reviewDialog){const rect=reviewDialog.getBoundingClientRect();if(e.clientX<rect.left||e.clientX>rect.right||e.clientY<rect.top||e.clientY>rect.bottom)closeReview();}});
 await refresh(Object.keys(localCatalog.items).filter(id=>localCatalog.items[id].ownership==='turtleson'));
 const query=new URL(location.href).searchParams;const color=landing?(localCatalog.products["briggs-1-4-zip"].colors.includes(query.get('color'))?query.get('color'):"Shadow"):selectedColor();showState(color,query.get('look'));
 if(!landing){const check=()=>{const color=selectedColor();if(color!==state?.color)showState(color);};document.addEventListener('change',()=>setTimeout(check,0),{capture:true,signal:lifetime.signal});document.addEventListener('click',event=>{if(event.target.closest('.product__color-swatch'))setTimeout(check,80);},{signal:lifetime.signal});document.addEventListener('product:variant-change',()=>setTimeout(check,0),{signal:lifetime.signal});const target=document.querySelector('[data-section-type="product"][data-product-handle="briggs-1-4-zip"]');if(target){observer=new MutationObserver(check);observer.observe(target,{subtree:true,attributes:true,attributeFilter:['class']});}}
 else window.addEventListener('popstate',()=>{const q=new URL(location.href).searchParams;showState(localCatalog.products["briggs-1-4-zip"].colors.includes(q.get('color'))?q.get('color'):"Shadow",q.get('look'));},{signal:lifetime.signal});
 try{if(unresolved){const current=await request(rootPath+'cart.js');if(attemptStatus(current,unresolved.attempt,unresolved.lines)==='complete'){sessionStorage.removeItem('turtleson-wl-pending');unresolved=null;}else notify('An earlier addition needs review. Check your cart before adding another look.');}}catch{}
}
function initializeAll(){document.querySelectorAll('[data-wardrobe-logic]').forEach(host=>initialize(host).catch(()=>{host.querySelector('[data-wl-studio]').innerHTML='<p>Wardrobe Logic is temporarily unavailable. Please refresh the page.</p>';}));}
window.TurtlesonWardrobeLogic={initializeAll};
initializeAll();document.addEventListener('shopify:section:load',initializeAll);

document.addEventListener('shopify:section:unload',event=>{for(const [host,dispose] of controllers)if(event.target.contains(host)){dispose();controllers.delete(host);}});

})();
